import * as i0 from '@angular/core';
import { Injectable, Optional, Inject, Component, Pipe, EventEmitter, Input, Output, HostListener, ViewChild, TemplateRef, ContentChild, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import * as i6 from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i6$2 from '@angular/cdk/portal';
import { PortalModule } from '@angular/cdk/portal';
import * as i7 from '@angular/material/legacy-button';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import * as i1$2 from '@angular/material/legacy-dialog';
import { MAT_LEGACY_DIALOG_DATA, MatLegacyDialogConfig, MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import * as i2 from '@angular/material/legacy-progress-spinner';
import { MatLegacyProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import { MatLegacyOptionModule } from '@angular/material/legacy-core';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import * as i3 from '@angular/material/legacy-menu';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import * as i9 from '@angular/material/legacy-card';
import { MatLegacyCardModule } from '@angular/material/legacy-card';
import * as i8 from '@angular/material/legacy-tooltip';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import * as i2$1 from '@angular/cdk/overlay';
import { OverlayConfig, OverlayModule } from '@angular/cdk/overlay';
import * as i6$1 from '@kolkov/angular-editor';
import { AngularEditorModule } from '@kolkov/angular-editor';
import * as i1 from '@pershing/pershing-core';
import { PershingError, PershingHttpUtil, PershingTranslationService, PershingCoreModule, AccountContextValue, ClientContextValue, HouseholdContextValue, GroupContextValue } from '@pershing/pershing-core';
import * as i11 from '@pershing/pershing-common';
import { PershingCommonModule } from '@pershing/pershing-common';
import { PerNgPlatformServiceModule } from '@pershing/per-ng-platform-service';
import * as i1$1 from '@angular/common/http';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Subject, of, ReplaySubject } from 'rxjs';
import { takeUntil, timeout } from 'rxjs/operators';
import * as i4 from '@angular/common';
import * as i4$1 from '@ngx-translate/core';
import * as i1$3 from '@angular/platform-browser';
import * as i5 from '@angular/router';
import * as i3$1 from '@angular/material/legacy-snack-bar';
import moment from 'moment-timezone';
import * as i4$2 from '@ngu/carousel';
import { NguCarouselModule } from '@ngu/carousel';
import { MatLegacyRadioModule } from '@angular/material/legacy-radio';
import * as i8$1 from 'ng2-pdf-viewer';
import { PdfViewerModule } from 'ng2-pdf-viewer';

class ContentManagementServiceDefinition {
    static instance;
    uri = 'webcontent';
    version = 'v1';
    family = 'netxinvestor';
    appName = 'webcontent-svc';
    serviceName = 'app';
    mnemonic = 'nxc';
    static getInstance() {
        if (!ContentManagementServiceDefinition.instance) {
            ContentManagementServiceDefinition.instance = new ContentManagementServiceDefinition();
        }
        return ContentManagementServiceDefinition.instance;
    }
    constructor() { }
}

let headers = new HttpHeaders({
    'Content-Type': 'application/json'
});
class ContentManagementService {
    serviceRouter;
    http;
    content$;
    error$;
    _content;
    _error;
    baseUrl;
    dataStore;
    constructor(serviceRouter, http) {
        this.serviceRouter = serviceRouter;
        this.http = http;
        this._error = new BehaviorSubject(new PershingError('', ''));
        this.error$ = this._error.asObservable();
        this._content = new BehaviorSubject(null);
        this.content$ = this._content.asObservable();
        this.baseUrl = this.serviceRouter.getServiceRouteURL(ContentManagementServiceDefinition.getInstance(), { ignoreOptions: { serviceVersion: true } });
        console.log('baseURL', this.baseUrl);
    }
    /**
     * Gets an Observable of type HttpResponse<any> (or) Observable<null> when making the request for preferences.
     * ** catch block is used primarily for observable stream continuation in case of errors during http call
     * @return Observable<HttpResponse<any>> | Observable<{}}>
     */
    retrieveContent(communityName, articleId, themeType, siteName, language) {
        return this.http.post(`${this.baseUrl}/${communityName}/${articleId}/${themeType}/${siteName}/${language}`, { headers: headers });
    }
    setError(errorMessage, errorCode) {
        this._error.next(new PershingError(errorMessage, 'contentService', errorCode));
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ContentManagementService, deps: [{ token: i1.ServiceRouter }, { token: i1$1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ContentManagementService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ContentManagementService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.ServiceRouter }, { type: i1$1.HttpClient }]; } });

class ContentStudioService {
    http;
    serviceRouter;
    appSettings;
    baseUrl = '';
    getContentURL = '';
    writeContentURL = '';
    siteUrl;
    stagingSiteUrl;
    constructor(http, serviceRouter, appSettings) {
        this.http = http;
        this.serviceRouter = serviceRouter;
        this.appSettings = appSettings;
        this.baseUrl = this.serviceRouter.getServiceRouteURL(ContentManagementServiceDefinition.getInstance(), { ignoreOptions: { serviceVersion: true } });
    }
    getContent(siteId, stagingSiteId, contentName, contentPath, contentHierarchy, isStaging, isComingFromCreatedSite) {
        let getUrl = `${this.baseUrl}/textContent/${siteId}/${stagingSiteId}/${contentName}?isStaging=${isStaging}&isComingFromCreatedSite=${isComingFromCreatedSite}&contentPath=${contentPath}`;
        if (contentHierarchy && contentHierarchy.length > 0) {
            getUrl += `&hierarchy=${contentHierarchy.join(',')}`;
        }
        return this.http.get(getUrl);
    }
    writeContent(siteId, stagingSiteId, contentName, contentPath, stagingContentPath, contentTitle, contentText, userId) {
        this.writeContentURL = `${this.baseUrl}/write/textContent/${siteId}/${stagingSiteId}?contentPath=${contentPath}&stagingContentPath=${stagingContentPath}&user=${userId}`;
        let writeBody = {
            articleID: contentName,
            title: contentTitle,
            content: contentText
        };
        return this.http.post(this.writeContentURL, writeBody);
    }
    getImageContent(siteId, stagingSiteId, contentName, contentPath, contentHierarchy, isStaging, isComingFromCreatedSite) {
        let getUrl = `${this.baseUrl}/imageContent/${siteId}/${stagingSiteId}?contentName=${contentName}&isStaging=${isStaging}&isComingFromCreatedSite=${isComingFromCreatedSite}&contentPath=${contentPath}`;
        if (contentHierarchy && contentHierarchy.length > 0) {
            getUrl += `&hierarchy=${contentHierarchy.join(',')}`;
        }
        return this.http.get(getUrl);
    }
    writeImageContent(siteId, stagingSiteId, contentPath, stagingContentPath, contentName, file, userId) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('contentPath', contentPath);
        formData.append('stagingContentPath', stagingContentPath);
        formData.append('contentName', contentName);
        formData.append('user', userId);
        this.writeContentURL = `${this.baseUrl}/write/imageContent/${siteId}/${stagingSiteId}`;
        return this.http.post(this.writeContentURL, formData);
    }
    deleteContent(siteId, contentName, contentPath, isStaticImage) {
        this.getContentURL = this.baseUrl + '/deleteContent/' + siteId + '?' +
            'contentName=' + contentName +
            '&contentPath=' + contentPath +
            '&isStaticImage=' + isStaticImage;
        return this.http.get(this.getContentURL);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ContentStudioService, deps: [{ token: i1$1.HttpClient }, { token: i1.ServiceRouter }, { token: 'AppSettings', optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ContentStudioService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ContentStudioService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: i1.ServiceRouter }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['AppSettings']
                }] }]; } });

const textEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: '',
    showToolbar: true,
    toolbarHiddenButtons: [
        [
            'heading',
            'fontName',
            'justifyLeft',
            'justifyCenter',
            'justifyRight',
            'justifyFull'
        ],
        [
            //'fontSize',
            'textColor',
            'backgroundColor',
            'customClasses',
            'link',
            'unlink',
            'insertVideo',
            'insertHorizontalRule',
            'removeFormat',
            'toggleEditorMode'
        ]
    ]
};
const textTitleEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '3rem',
    minHeight: '3rem',
    placeholder: 'Enter title here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: '',
    sanitize: true,
    showToolbar: true,
    toolbarHiddenButtons: [
        [
            'heading',
            'fontName',
            'justifyLeft',
            'justifyCenter',
            'justifyRight',
            'justifyFull',
            'indent',
            'outdent',
            'insertUnorderedList',
            'insertOrderedList'
        ],
        [
            'fontSize',
            'backgroundColor',
            'customClasses',
            'link',
            'unlink',
            'insertImage',
            'insertVideo',
            'insertHorizontalRule',
            'removeFormat',
            'toggleEditorMode'
        ]
    ]
};

class ContentManagementConstants {
    static webContentsWithScript = [
        '/nxi/disclosure/brokeragedisclosure/exchangeagreements',
        'nxi/disclosure/brokeragedisclosure/exchangeagreements/nasdaqomxterms',
        '/nxi/disclosure/bankcustodydisclosures/exchangeagreements',
        'nxi/disclosure/bankcustodydisclosures/exchangeagreements/nasdaqomxterms',
        '/nxi/disclosure/tradingdisclosure/exchangeagreements',
        'nxi/disclosure/tradingdisclosure/exchangeagreements/nasdaqomxterms'
    ];
    static postLoginUrls = [
        '/nxi/advisor-home'
    ];
}
class CMSEvents {
    static EDIT_COMPONENT = 'pershing.assembly.edit.EditComponent';
    static EDIT_COMPONENT_COMPLETE = 'pershing.assembly.edit.EditComponentCompleted';
    static EDIT_CONTENT_VERSION_UPDATE = 'sitebuilder.cms.edit.contentVersion';
    static PLACE_ONETRUST = 'pershing.content.management.placeontrust';
}
class CustomHeader {
    static propertyMap = new Map([
        ['55G', new Map([['about_us_login', 'welcome']])],
        ['3CR', new Map([['cookie_notice', 'cookie_notice_custom'], ['privacy_policy', 'privacy_policy_custom']])],
        ['3Z1', new Map([['cookie_notice', 'cookie_notice_custom'], ['privacy_policy', 'privacy_policy_custom']])],
        ['BBA', new Map([['cookie_notice', 'cookie_notice_custom'], ['privacy_policy', 'privacy_policy_custom']])],
        ['55G', new Map([['cookie_notice', 'cookie_notice_custom'], ['privacy_policy', 'privacy_policy_custom']])],
        ['5QH', new Map([['site_specific_resources', 'external_links']])],
        ['56M', new Map([['site_specific_resources', 'external_links']])],
        ['NSC', new Map([['site_specific_resources', 'external_links']])],
        ['41K', new Map([['about_us_login', 'international_brokerage'], ['links', 'links_watani']])],
        ['H1X', new Map([['contact_us_login', 'need_assistance']])],
        ['cpwm', new Map([['contact_us_login', 'need_assistance']])],
        ['C01', new Map([['contact_us_login', 'need_assistance'], ['cookie_notice', 'cookie_notice_custom'], ['privacy_policy', 'privacy_policy_custom']])],
        ['5DC', new Map([['business_continuity', 'dreyfus_business_continuity']])],
        ['XGW', new Map([['custom_contactus', 'customer_contact_us']])],
        ['NV6', new Map([['path_to_investing', 'external_links']])],
        ['33L', new Map([['custom_contactus', 'head_quarters']])],
        ['44A', new Map([['site_specific_resources', 'external_links']])],
        ['PEC', new Map([['site_specific_resources', 'external_links']])],
        ['netxinvestor', new Map([['privacy_policy', 'privacy_policy_custom']])],
        ['028', new Map([['netx_investor_mobile_solutions', 'mobile_solution'], ['netx_investor_mobile_solutions_about', 'mobile_solution']])],
        ['TM9', new Map([['contact_us_login', 'invertis_contact_us'], ['custom_contactus', 'invertis_contact_us'],
                ['invertis_security_recommendations', 'invertis_security_recommendations']])]
    ]);
}

class ProgressDialogComponent {
    data;
    message = '';
    showprogress = true;
    constructor(data) {
        this.data = data;
    }
    ngOnInit() {
        if (this.data) {
            this.message = this.data.message || this.message;
            this.showprogress = this.data.showprogress || this.showprogress;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProgressDialogComponent, deps: [{ token: MAT_LEGACY_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ProgressDialogComponent, selector: "progress-dialog", ngImport: i0, template: "<mat-dialog-content [style.overflow]=\"'hidden'\">\n    <div class=\"margin-top-20 center-align\">\n        <div *ngIf=\"!!message; else defaultMsg\">{{message}}</div>\n        <ng-template #defaultMsg>\n            <div>{{ 'CMS.DEFAULT_PROGRESS_MSG' | translate }}</div>\n        </ng-template>\n        <mat-spinner *ngIf=showprogress></mat-spinner>\n    </div>\n</mat-dialog-content>", dependencies: [{ kind: "directive", type: i1$2.MatLegacyDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "component", type: i2.MatLegacyProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "diameter", "strokeWidth", "mode", "value"], exportAs: ["matProgressSpinner"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i4$1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProgressDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'progress-dialog', template: "<mat-dialog-content [style.overflow]=\"'hidden'\">\n    <div class=\"margin-top-20 center-align\">\n        <div *ngIf=\"!!message; else defaultMsg\">{{message}}</div>\n        <ng-template #defaultMsg>\n            <div>{{ 'CMS.DEFAULT_PROGRESS_MSG' | translate }}</div>\n        </ng-template>\n        <mat-spinner *ngIf=showprogress></mat-spinner>\n    </div>\n</mat-dialog-content>" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_LEGACY_DIALOG_DATA]
                }] }]; } });

class SafePipe {
    sanitizer;
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(value, type) {
        switch (type) {
            case 'html':
                return this.sanitizer.bypassSecurityTrustHtml(value);
            case 'style':
                return this.sanitizer.bypassSecurityTrustStyle(value);
            case 'script':
                return this.sanitizer.bypassSecurityTrustScript(value);
            case 'url':
                return this.sanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl':
                return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            default:
                return undefined;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SafePipe, deps: [{ token: i1$3.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: SafePipe, name: "safe" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SafePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'safe'
                }]
        }], ctorParameters: function () { return [{ type: i1$3.DomSanitizer }]; } });

class CMSTextComponent {
    logService;
    contentservice;
    appSettings;
    translationService;
    dialog;
    translate;
    siteId; // specify the site id in Crafter
    stagingSiteId; // specify the site id in Crafter
    // contentPath initial value set to make sure the root of hierarchy is retail/generic
    contentPath = 'retail/generic'; // pass to backend to know where to save the content and read the content
    stagingContentPath = ''; // pass to backend to know where to save the content
    contentName; // aka file name, internal name, article id. ex: ABOUT_US
    titleContentName; // the name how we call this content. ex: About Us
    contentHierarchy = [];
    contentVersion = ''; // for future support versioning
    componentId = ''; // passed from siteTemplate, used for page edit
    userId = 'dummyUser';
    isStaging;
    isEditOnlyMode = false; // For Overwriting toggle mode and keep the component always in edit mode.
    onPreviewContent = new EventEmitter(); // Consuming component could emit event to delete the content.
    deleteContentEventEmitter;
    isComingFromCreatedSite = true; // to differentiate the component being used in SB or actual site
    cmsLocale = 'en';
    showContentHeader;
    config = textEditorConfig;
    titleConfig = textTitleEditorConfig;
    persistedText = '';
    persistedTitle = '';
    htmlContent = '';
    titleHtmlContent = '';
    isEditMode = false;
    titlePlaceHolderText = '';
    bodyPlaceHolderText = '';
    prefixTitlePlaceHolderText = 'Enter Title Here for ';
    prefixBodyPlaceHolderText = 'Enter Text Here for ';
    isFromSiteBuilder;
    disableSave = true;
    isSitebuilderCMSEnabled = false;
    cdnHost = '';
    language = '';
    unsubscribe = new Subject();
    constructor(logService, contentservice, appSettings, translationService, dialog, translate) {
        this.logService = logService;
        this.contentservice = contentservice;
        this.appSettings = appSettings;
        this.translationService = translationService;
        this.dialog = dialog;
        this.translate = translate;
    }
    ngOnInit() {
        this.siteId = this.siteId || this.appSettings.cms.siteId;
        this.stagingSiteId =
            this.stagingSiteId || this.appSettings.cms.stagingSiteId;
        this.isStaging = this.isStaging || this.appSettings.ibdConfigMap.staging;
        this.translationService.addTranslationFolder('@pershing/nxi-ng-common', 'node_modules/@pershing/nxi-ng-common/lib');
        this.isFromSiteBuilder = !this.isComingFromCreatedSite;
        this.isEditMode = this.isEditOnlyMode ? true : false;
        this.language = this.translate.currentLang;
        this.cdnHost = this.appSettings.siteCdnUrl;
        this.isSitebuilderCMSEnabled = this.appSettings.isSitebuilderCMSEnabled;
        if (this.isSitebuilderCMSEnabled) {
            this.resolvePaths();
            this.getContent();
        }
        else {
            this.fetchContentFromAkamai();
        }
        if (!!this.titleContentName) {
            // this.titlePlaceHolderText = this.translationService.translate.instant('CMS.TEXT_TITLE_PROMPT') + this.titleContentName;
            // this.bodyPlaceHolderText = this.translationService.translate.instant('CMS.TEXT_BODY_PROMPT')  + this.titleContentName;
            // TODO:  Above not translated.  Use below for now.
            this.titlePlaceHolderText =
                this.prefixTitlePlaceHolderText + this.titleContentName;
            this.bodyPlaceHolderText =
                this.prefixBodyPlaceHolderText + this.titleContentName;
        }
        if (this.deleteContentEventEmitter) {
            this.deleteContentEventEmitter
                .pipe(takeUntil(this.unsubscribe))
                .subscribe((msg) => {
                if (msg && msg.contentName === this.contentName) {
                    // TODO:  Rename this to 'updateContent' and check for specific action.
                    // this.deleteContent();
                    this.htmlContent =
                        '<div style="display:none" id="hidden-cms-text"></div>';
                    this.titleHtmlContent =
                        '<div style="display:none" id="hidden-cms-title"></div>';
                    this.writeContent();
                }
            });
        }
    }
    /**
     * To resolve contentPath and stagingContentPath.
     * Will try to obtain the URL either from Input or appSettings then take that URL turn into path in Crafter
     * ex: somesite.netxinvestor.com => will get us contentPath === retail/somesite-netxinvestor-com/conservative/en
     */
    resolvePaths() {
        // This component is used by both SB and NXI.  Further SB use this for both edit and non edit mode (preview.)
        // @Input generally for initial value while appSettings is for specific app.
        // contentPath should not be generic or default.  Add it to hierarchy instead to ensure generic is not being considered first.
        if (!!this.contentPath && this.contentPath.indexOf('generic') > 0) {
            this.contentHierarchy.push(this.contentPath);
            this.contentPath = '';
        }
        // when edit the content from SB, we should pass it through input on where to save the content
        // if it's there, don't try to resolve contentpath again
        if (!this.contentPath &&
            !this.stagingContentPath &&
            this.appSettings &&
            this.appSettings.ibdConfigMap &&
            !!this.appSettings.ibdConfigMap.URL) {
            // resolve theme type
            let themeType = 'conservative';
            let siteUrl = '';
            let stagingSiteUrl = '';
            if (this.appSettings.isSitebuilder) {
                // Check if it (demo) site that is used for preview an ibd else SB site community has staging or publish prefix so remove that.
                siteUrl = !!this.appSettings.previewSite
                    ? this.appSettings.previewSite
                    : this.appSettings.ibdConfigMap.URL;
                siteUrl = this.massageUrl(siteUrl); // removing staging prefix and replace . with -
                stagingSiteUrl = this.resolveStagingSiteUrl();
                stagingSiteUrl = this.massageUrl(stagingSiteUrl);
                // path in Crafter consists of platform + site URL (sub domain & domain) + theme.
                this.contentPath =
                    this.appSettings.platform + '/' + siteUrl + '/' + themeType;
                this.stagingContentPath =
                    this.appSettings.platform + '/' + stagingSiteUrl + '/' + themeType;
            }
            else {
                // this else block is for something in the future
                this.contentPath = this.appSettings.ibdConfigMap.URL.replace(/\./g, '-');
            }
        }
        if (this.isComingFromCreatedSite) {
            this.contentPath += `/${this.translationService.userLang}`;
            this.stagingContentPath += `/${this.translationService.userLang}`;
        }
        else {
            this.contentPath += `/${this.cmsLocale}`;
            this.stagingContentPath += `/${this.cmsLocale}`;
        }
    }
    /**
     * Get url of the site from appSettings then based on region return the staging url
     * ex: somesite.qa.netxinvestor.com => somesite.test.netxinvestor.com
     * @returns the staging url
     */
    resolveStagingSiteUrl() {
        let url = this.appSettings.ibdConfigMap.URL;
        if (!this.isStaging) {
            const currentRegion = url.split('.')[1]; // dev, test, qa, netxinvestor
            const domain = url.substr(url.indexOf('.', url.indexOf('.') + 1) + 1);
            if (currentRegion === 'dev' || currentRegion === 'test') {
                return this.appSettings.ibdConfigMap.community + '.dev.' + domain;
            }
            else if (currentRegion === 'qa') {
                return this.appSettings.ibdConfigMap.community + '.test.' + domain;
            }
            else {
                return (this.appSettings.ibdConfigMap.community +
                    '.qa.' +
                    url.substr(url.indexOf('.') + 1));
            }
        }
        else {
            return url;
        }
    }
    /**
     * For usecase when in Iframe, will receive message from parent
     * @param event event
     */
    receiveMessage(event) {
        if (event &&
            event.data &&
            event.data.action &&
            event.data.action === 'previewContent' &&
            event.data.contentName &&
            event.data.contentName === this.contentName) {
            this.titleHtmlContent =
                event.data && event.data.titleText
                    ? this.encloseWithH2(event.data.titleText)
                    : '';
            this.htmlContent =
                event.data && event.data.bodyText ? event.data.bodyText : '';
        }
    }
    editComponentEventListener(event) {
        // Check to see if the componentId in the payload coorelates to our contentName
        if (event &&
            event.detail &&
            event.detail.data &&
            event.detail.data.componentId === this.componentId) {
            this.toggleEditMode(true);
        }
    }
    toggleEditMode(isOn) {
        this.isEditMode = this.isEditOnlyMode ? true : isOn;
    }
    getContent() {
        // always fetch staging site content when coming from SB
        let pathToGetContent = this.isFromSiteBuilder
            ? this.stagingContentPath
            : this.contentPath;
        this.contentservice
            .getContent(this.siteId, this.stagingSiteId, this.contentName, pathToGetContent, this.contentHierarchy, this.isStaging, this.isComingFromCreatedSite)
            .pipe(takeUntil(this.unsubscribe))
            .subscribe((res) => {
            this.processReponse(res);
            if (this.isEditOnlyMode) {
                // For editing, need the editor show either (2) specific site content or (2) default content, then emit the content for preview.
                // For the case when user previouly selected to completely hide the content, we need to pull generic text.
                let hasHidenTitle = !!this.titleHtmlContent &&
                    this.titleHtmlContent.indexOf('hidden-cms-title') > 0;
                let hasHidenText = !!this.htmlContent &&
                    this.htmlContent.indexOf('hidden-cms-text') > 0;
                if (hasHidenTitle && hasHidenText) {
                    // Previously chosen not to be displayed but now want to display so get generic text.
                    this.getGenericContent();
                }
                else {
                    this.previewContent('initContent');
                }
            }
        });
    }
    fetchContentFromAkamai() {
        let lang = this.language;
        let url = this.cdnHost;
        if (this.language == 'es') {
            lang = 'es';
        }
        let func = (function (contentName, thisObj) {
            let abc = contentName;
            window[abc] = function (data) {
                if (data !== undefined && data !== null) {
                    thisObj.processResponseFromAkamai(data);
                }
            };
        })(this.contentName, this);
        let scriptElement = document.createElement('script');
        // Set the src and id attributes of the script element
        scriptElement.src =
            url + '/webcontent/' + lang + '/' + this.contentName + '.js';
        scriptElement.type = 'text/javascript';
        // Get the head element
        let node = document.getElementsByTagName('head')[0];
        node.appendChild(scriptElement);
    }
    processResponseFromAkamai(data) {
        if (data) {
            this.htmlContent = data.substring(data.indexOf('<body>') + 6, data.indexOf('</body>'));
            this.titleHtmlContent = data.substring(data.indexOf('<title>') + 7, data.indexOf('</title>'));
            let titleContent = this.titleHtmlContent.replace(/(<([^>]+)>)/gi, '');
            let contentLink = document.getElementsByName('cms-text-link-' + this.contentName);
            if (contentLink && contentLink.length > 0) {
                contentLink[0].innerHTML = titleContent;
            }
        }
        this.persistedTitle = this.titleHtmlContent;
        this.persistedText = this.htmlContent;
        this.previewContent('initContent');
    }
    getGenericContent() {
        this.contentservice
            .getContent(this.siteId, this.stagingSiteId, this.contentName, 'retail/generic', this.contentHierarchy, this.isStaging, this.isComingFromCreatedSite)
            .pipe(takeUntil(this.unsubscribe))
            .subscribe((res) => {
            this.processReponse(res);
            this.previewContent('initContent');
            this.disableSave = false;
        });
    }
    processReponse(res) {
        this.logService.info(res);
        let stringifiedData = JSON.stringify(res);
        let parsedJson = JSON.parse(stringifiedData);
        let content = parsedJson['response'];
        if (content) {
            stringifiedData = JSON.stringify(content);
            parsedJson = JSON.parse(stringifiedData);
            this.htmlContent = parsedJson['content'] || '';
            this.titleHtmlContent = parsedJson['title'] || '';
            let titleContent = this.titleHtmlContent.replace(/(<([^>]+)>)/gi, '');
            let contentLink = document.getElementsByName('cms-text-link-' + this.contentName);
            if (contentLink && contentLink.length > 0) {
                contentLink[0].innerHTML = titleContent;
            }
        }
        this.persistedTitle = this.titleHtmlContent;
        this.persistedText = this.htmlContent;
    }
    writeContent() {
        this.persistedText = this.htmlContent;
        this.persistedTitle = this.encloseWithH2(this.titleHtmlContent);
        this.toggleEditMode(false);
        let dialogRef = this.dialog.open(ProgressDialogComponent, {
            width: '350px',
            height: '200px',
            panelClass: ['modal'],
        });
        this.contentservice
            .writeContent(this.siteId, this.stagingSiteId, this.contentName, this.contentPath, this.stagingContentPath, this.persistedTitle, this.persistedText, this.userId)
            .pipe(takeUntil(this.unsubscribe))
            .subscribe((res) => {
            this.logService.info(res);
            let stringifiedData = JSON.stringify(res);
            let parsedJson = JSON.parse(stringifiedData);
            let data = {
                action: CMSEvents.EDIT_CONTENT_VERSION_UPDATE,
                contentName: this.contentName,
                contentVersion: parsedJson['response']['contentVersion'],
            };
            window.parent.postMessage(JSON.parse(JSON.stringify(data)));
            if (this.isEditOnlyMode) {
                this.previewContent('saveContent');
            }
            dialogRef.close();
            this.disableSave = true;
        });
    }
    deleteContent() {
        this.contentservice
            .deleteContent(this.siteId, this.contentName, this.contentPath, false)
            .pipe(takeUntil(this.unsubscribe))
            .subscribe((res) => {
            this.logService.info(res);
            this.htmlContent = '';
            this.titleHtmlContent = '';
            this.toggleEditMode(false);
        });
    }
    cancelContent() {
        this.htmlContent = this.persistedText;
        this.titleHtmlContent = this.persistedTitle;
        this.disableSave = true;
        this.toggleEditMode(false);
        if (this.isEditOnlyMode) {
            this.previewContent('cancelContent');
        }
    }
    /**
     * For SB create site flow where user would like to see the preview of CMS
     * in the context of NXI site which rendered within Pershing iframe to update itself.
     * This is to emit content to parent, so parent will then pass message into ifrmae
     * @param previewOnAction === previewContent
     */
    previewContent(previewOnAction) {
        this.onPreviewContent.emit({
            contentName: this.contentName,
            titleText: this.titleHtmlContent,
            bodyText: this.htmlContent,
            action: 'previewContent',
            previewOn: previewOnAction,
        });
    }
    /**
     * To ensure the content's title is enclosed by h2 element
     * @param contentTitle content's title in html text
     * @returns contentTitle enclosed by h2 element
     */
    encloseWithH2(contentTitle) {
        if (!!contentTitle &&
            (contentTitle.indexOf('hidden-cms-title') > 0 ||
                contentTitle.indexOf('<h2>') === 0)) {
            return contentTitle;
        }
        else if (!!contentTitle) {
            return '<h2>' + contentTitle + '</h2>'; // add h2 only if contentTitle is not empty
        }
        else {
            return ''; // Do not return empty heading tag as it is accessibility violation
        }
    }
    /**
     *
     * @param siteUrl Remove staging- prefix and replace . with -
     */
    massageUrl(siteUrl) {
        let path = '';
        if (!!siteUrl) {
            // Remove prefix 'staging-' and convert all dot to dash.
            let domain = siteUrl.indexOf('?') > 0
                ? siteUrl.slice(0, siteUrl.indexOf('?'))
                : siteUrl;
            path = domain.replace('staging-', '').replace(/\./g, '-');
        }
        return path;
    }
    onChange() {
        this.disableSave =
            this.persistedTitle === this.titleHtmlContent &&
                this.persistedText === this.htmlContent;
    }
    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CMSTextComponent, deps: [{ token: i1.LogService }, { token: ContentStudioService }, { token: 'AppSettings', optional: true }, { token: i1.PershingTranslationService }, { token: i1$2.MatLegacyDialog }, { token: i4$1.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CMSTextComponent, selector: "cms-text", inputs: { siteId: "siteId", stagingSiteId: "stagingSiteId", contentPath: "contentPath", stagingContentPath: "stagingContentPath", contentName: "contentName", titleContentName: "titleContentName", contentHierarchy: "contentHierarchy", contentVersion: "contentVersion", componentId: "componentId", userId: "userId", isStaging: "isStaging", isEditOnlyMode: "isEditOnlyMode", deleteContentEventEmitter: "deleteContentEventEmitter", isComingFromCreatedSite: "isComingFromCreatedSite", cmsLocale: "cmsLocale", showContentHeader: "showContentHeader" }, outputs: { onPreviewContent: "onPreviewContent" }, host: { listeners: { "window:message": "receiveMessage($event)", "document:pershing.assembly.edit.EditComponent": "editComponentEventListener($event)" } }, ngImport: i0, template: "<div *ngIf=\"isEditMode\" class=\"cms-Text-ContainerEdit\">\n  <angular-editor [placeholder]=\"!!titlePlaceHolderText ? titlePlaceHolderText : 'CMS.TEXT_TITLE_PROMPT' | translate\" [(ngModel)]=\"titleHtmlContent\" [config]=\"titleConfig\" (ngModelChange)=\"onChange()\"></angular-editor>\n\t<br />\n  <angular-editor [placeholder]=\"!!bodyPlaceHolderText ? bodyPlaceHolderText: 'CMS.TEXT_BODY_PROMPT' | translate\" [(ngModel)]=\"htmlContent\" [config]=\"config\" (ngModelChange)=\"onChange()\"></angular-editor>\n  <div class=\"margin-top-10\">\n    <button *ngIf=\"isEditOnlyMode\" mat-raised-button class=\"margin-right-10\" color=\"primary\" (click)=\"previewContent('previewContent');\">{{ 'CMS.PREVIEW' | translate }}</button>\n    <button mat-raised-button class=\"margin-right-10\" color=\"primary\" [disabled]=disableSave (click)=\"writeContent();\">{{ 'CMS.SAVE' | translate }}</button>\n    <!-- Do not show delete if isEditOnlyMode as this mode only intended for content step of the site creation flow -->\n    <button *ngIf=\"!isEditOnlyMode\" mat-raised-button color=\"primary\"  class=\"margin-right-10\"  (click)=\"deleteContent();\">{{ 'CMS.DELETE' | translate }}</button>\n    <button mat-raised-button color=\"primary\" (click)=\"cancelContent();\">{{ 'CMS.CANCEL' | translate }}</button>\n  </div>\n</div>\n<div *ngIf=\"!isEditMode\">\n  <div *ngIf=\"showContentHeader\" class=\"cms-title\" [innerHTML]=\"titleHtmlContent | safe: 'html'\"></div>\n  <div class=\"cms-body\" [innerHTML]=\"htmlContent | safe: 'html'\"></div>\n</div>", dependencies: [{ kind: "directive", type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i6$1.AngularEditorComponent, selector: "angular-editor", inputs: ["id", "config", "placeholder", "tabIndex"], outputs: ["html", "viewMode", "blur", "focus"] }, { kind: "component", type: i7.MatLegacyButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i4$1.TranslatePipe, name: "translate" }, { kind: "pipe", type: SafePipe, name: "safe" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CMSTextComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cms-text', template: "<div *ngIf=\"isEditMode\" class=\"cms-Text-ContainerEdit\">\n  <angular-editor [placeholder]=\"!!titlePlaceHolderText ? titlePlaceHolderText : 'CMS.TEXT_TITLE_PROMPT' | translate\" [(ngModel)]=\"titleHtmlContent\" [config]=\"titleConfig\" (ngModelChange)=\"onChange()\"></angular-editor>\n\t<br />\n  <angular-editor [placeholder]=\"!!bodyPlaceHolderText ? bodyPlaceHolderText: 'CMS.TEXT_BODY_PROMPT' | translate\" [(ngModel)]=\"htmlContent\" [config]=\"config\" (ngModelChange)=\"onChange()\"></angular-editor>\n  <div class=\"margin-top-10\">\n    <button *ngIf=\"isEditOnlyMode\" mat-raised-button class=\"margin-right-10\" color=\"primary\" (click)=\"previewContent('previewContent');\">{{ 'CMS.PREVIEW' | translate }}</button>\n    <button mat-raised-button class=\"margin-right-10\" color=\"primary\" [disabled]=disableSave (click)=\"writeContent();\">{{ 'CMS.SAVE' | translate }}</button>\n    <!-- Do not show delete if isEditOnlyMode as this mode only intended for content step of the site creation flow -->\n    <button *ngIf=\"!isEditOnlyMode\" mat-raised-button color=\"primary\"  class=\"margin-right-10\"  (click)=\"deleteContent();\">{{ 'CMS.DELETE' | translate }}</button>\n    <button mat-raised-button color=\"primary\" (click)=\"cancelContent();\">{{ 'CMS.CANCEL' | translate }}</button>\n  </div>\n</div>\n<div *ngIf=\"!isEditMode\">\n  <div *ngIf=\"showContentHeader\" class=\"cms-title\" [innerHTML]=\"titleHtmlContent | safe: 'html'\"></div>\n  <div class=\"cms-body\" [innerHTML]=\"htmlContent | safe: 'html'\"></div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: i1.LogService }, { type: ContentStudioService }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['AppSettings']
                }] }, { type: i1.PershingTranslationService }, { type: i1$2.MatLegacyDialog }, { type: i4$1.TranslateService }]; }, propDecorators: { siteId: [{
                type: Input
            }], stagingSiteId: [{
                type: Input
            }], contentPath: [{
                type: Input
            }], stagingContentPath: [{
                type: Input
            }], contentName: [{
                type: Input
            }], titleContentName: [{
                type: Input
            }], contentHierarchy: [{
                type: Input
            }], contentVersion: [{
                type: Input
            }], componentId: [{
                type: Input
            }], userId: [{
                type: Input
            }], isStaging: [{
                type: Input
            }], isEditOnlyMode: [{
                type: Input
            }], onPreviewContent: [{
                type: Output
            }], deleteContentEventEmitter: [{
                type: Input
            }], isComingFromCreatedSite: [{
                type: Input
            }], cmsLocale: [{
                type: Input
            }], showContentHeader: [{
                type: Input
            }], receiveMessage: [{
                type: HostListener,
                args: ['window:message', ['$event']]
            }], editComponentEventListener: [{
                type: HostListener,
                args: ['document:' + CMSEvents.EDIT_COMPONENT, ['$event']]
            }] } });

class ContentManagementComponent {
    translationService;
    pershingDecimalPipe;
    zone;
    logService;
    sanitizer;
    serviceRouter;
    translate;
    authService;
    location;
    router;
    communityName;
    articleId;
    isHeaderRequired = false;
    isFooter = false;
    entitlement;
    doNotOverrideCommunityName = false;
    hasContent = new EventEmitter();
    isEntitledforView;
    content;
    header = '';
    error$;
    _error;
    contentSubscription;
    ibdCustSupportPhone;
    ibdName;
    documentsVersion;
    cdnHost;
    currentYear;
    isLoggedIn;
    isAda = false;
    showBackButton = false;
    themetype;
    cmsVersion;
    siteName;
    currentUrl;
    ibd;
    language;
    titleId;
    isLazyLoadOneTrustPage = false;
    isSiteBuilderSite = false;
    // configure contents supported by sitebuilder in an array somewhere in nxi-contentmanagement as a constant
    siteBuilderContent; // editableCmsList (list of contents supported by sitebuilder)
    isSitebuilderContent = false;
    showHeader = true; // flag to show/hide header title for cms components
    homePage;
    hasData = false;
    contentDivRef;
    constructor(translationService, pershingDecimalPipe, zone, logService, sanitizer, serviceRouter, translate, authService, location, appSettings, router) {
        this.translationService = translationService;
        this.pershingDecimalPipe = pershingDecimalPipe;
        this.zone = zone;
        this.logService = logService;
        this.sanitizer = sanitizer;
        this.serviceRouter = serviceRouter;
        this.translate = translate;
        this.authService = authService;
        this.location = location;
        this.router = router;
        this.isLoggedIn = appSettings.isLoggedIn;
        this.translationService.addTranslationFolder('@pershing/nxi-ng-contentmanagement', 'node_modules/@pershing/nxi-ng-contentmanagement/app');
        this.currentUrl = this.router ? this.router.url : '';
        this._error = new BehaviorSubject(null);
        this.error$ = this._error.asObservable();
        this.cdnHost = appSettings.ibdConfigMap.cdnURL;
        this.currentYear = appSettings.currentYear;
        this.siteName = appSettings.cmsSiteName;
        this.language = this.translate.currentLang;
        this.ibd = appSettings.ibdConfigMap.IBD;
        this.isSiteBuilderSite = appSettings.isSitebuilder;
        this.homePage = appSettings.home;
        if (appSettings.ibdConfigMap) {
            let parsemap = appSettings.ibdConfigMap;
            this.ibdCustSupportPhone = parsemap.ibdCustSupportPhone;
            this.ibdName = parsemap.ibdName;
            this.documentsVersion = parsemap.documents_version;
            this.communityName = parsemap.community;
            this.themetype = appSettings.themeType;
            if (parsemap.editableCmsList) {
                this.siteBuilderContent = parsemap.editableCmsList;
            }
            this.cmsVersion = parsemap.cms_version;
        }
        if (this.themetype === 'ada') {
            this.isAda = true;
        }
        if (appSettings.isLazyLoadOneTrustPage) {
            this.isLazyLoadOneTrustPage = true;
        }
    }
    ngOnInit() {
        if (this.location.path().indexOf('/nxi/disclosure') === 0 && this.isLoggedIn) {
            this.showBackButton = true;
        }
        if (this.entitlement !== undefined) {
            this.isEntitledforView = this.authService.isEntitled(this.entitlement);
        }
        else {
            this.isEntitledforView = true;
        }
        this.translationService.get(this.articleId).subscribe(data => { this.header = data; });
        if (this.communityName === undefined || (this.isSiteBuilderSite && !this.doNotOverrideCommunityName)) {
            console.log('communityName is undefined. defaulting to netxinvestor');
            this.communityName = 'netxinvestor';
        }
        else if (this.communityName.includes('ada-')) {
            this.communityName = this.communityName.split('-')[1];
        }
        if (this.articleId === undefined) {
            console.log('articleId is ' + this.articleId);
        }
        if (this.siteBuilderContent) {
            this.siteBuilderContent = this.siteBuilderContent.filter(editableCms => editableCms['cmsId'] === this.articleId)[0];
        }
        this.isSitebuilderContent = this.showCmsText();
        this.showHeader = this.showContentHeader();
        if (!this.isSitebuilderContent) {
            this.createScriptDynamically();
        }
        this.titleId = this.articleId;
        // customized header are replaced below.
        if (CustomHeader.propertyMap.get(this.ibd) && CustomHeader.propertyMap.get(this.ibd).get(this.articleId)) {
            this.titleId = CustomHeader.propertyMap.get(this.ibd).get(this.articleId);
        }
        else if (CustomHeader.propertyMap.get(this.communityName) && CustomHeader.propertyMap.get(this.communityName).get(this.articleId)) {
            this.titleId = CustomHeader.propertyMap.get(this.communityName).get(this.articleId);
        }
    }
    // check if is sitebuilder and whether the article id supplied to contentmanagement exists in editableCmsList
    showCmsText() {
        return !!this.siteBuilderContent && this.isSiteBuilderSite;
    }
    showContentHeader() {
        return this.isSitebuilderContent && this.siteBuilderContent['showHeader'];
    }
    createScriptDynamically() {
        let lang = "";
        let url = this.cdnHost;
        if (this.language == "es") {
            lang = "es";
        }
        let adaUrl = "/staticartifacts/@pershing/cms@" + this.cmsVersion + "/components/ibds/" + this.communityName + "/ada/" + lang + "/" + this.articleId + ".xml.js";
        let modernUrl = "/staticartifacts/@pershing/cms@" + this.cmsVersion + "/components/ibds/" + this.communityName + "/modern/" + lang + "/" + this.articleId + ".xml.js";
        let customUrl = "/staticartifacts/@pershing/cms@" + this.cmsVersion + "/components/ibds/" + this.communityName + "/custom/" + lang + "/" + this.articleId + ".xml.js";
        if (this.themetype == "ada") {
            url = url + adaUrl;
        }
        else if (this.themetype == "modern") {
            url = url + modernUrl;
        }
        else {
            url = url + customUrl;
        }
        let func = function (articleId, thisObj) {
            let abc = articleId;
            window[abc] = function (data) {
                if (data !== undefined && data !== null) {
                    data = data.substring(data.indexOf("<body>") + 6, data.indexOf("</body>"));
                    console.log('fetchcontent method invoked --');
                    thisObj.fetchContentNxi(data);
                }
            };
        }(this.articleId, this);
        let scriptElement = document.createElement("script");
        // Set the src and id attributes of the script element
        //scriptElement.src = "http://localhost:8080/site/components/ibds/investor/custom/"+this.articleId+".xml.js";
        scriptElement.src = url;
        scriptElement.type = 'text/javascript';
        let node = document.getElementsByTagName("head")[0];
        node.appendChild(scriptElement);
    }
    fetchContentNxi(data) {
        if (data) {
            this.hasData = true;
            this.hasContent.emit({ articleId: this.articleId, hasContent: true });
            this.content = data
                .replace(new RegExp('"#"', 'g'), '"javascript:void(0);"')
                .replace(new RegExp('{ibdName}', 'g'), this.ibdName)
                .replace(new RegExp('{ibdCustSupportPhone}', 'g'), this.ibdCustSupportPhone)
                .replace(new RegExp('{currentYear}', 'g'), this.currentYear)
                .replace(new RegExp('{cdnHost}', 'g'), this.cdnHost)
                .replace(new RegExp('{documentsVersion}', 'g'), this.documentsVersion);
            if (!this.isLoggedIn) {
                ContentManagementConstants.postLoginUrls.forEach(element => {
                    this.content = this.content.replace(new RegExp(element, 'g'), '/nxi/login#');
                });
            }
            if (this.isLazyLoadOneTrustPage && this.articleId === 'cookie_notice') {
                const placeOneTrust = new CustomEvent(CMSEvents.PLACE_ONETRUST);
                document.dispatchEvent(placeOneTrust);
            }
            console.log('cms content ---');
            this.contentDivRef.nativeElement.innerHTML = this.content;
        }
        else {
            this.hasContent.emit({ articleId: this.articleId, hasContent: false });
        }
    }
    replaceLoginUrls() {
        if (!this.isLoggedIn) {
            ContentManagementConstants.postLoginUrls.forEach(element => {
                this.content = this.content.replace(new RegExp(element, 'g'), '/nxi/login#');
            });
        }
    }
    replaceHref() {
        if (this.isFooter) {
            // replace href in footer only
            this.content = this.content.replace(new RegExp(/href="\/(.*?)"/g), (_match, p1) => {
                let url = p1;
                url = `/${url}`;
                return `href="javascript: void(0)" onclick="handleFooterNavigation('${url}')"`;
            });
        }
    }
    dispatchOneTrust() {
        if (this.isLazyLoadOneTrustPage && this.articleId === 'cookie_notice') {
            const placeOneTrust = new CustomEvent(CMSEvents.PLACE_ONETRUST);
            document.dispatchEvent(placeOneTrust);
        }
    }
    setError(errorMessage, errorCode) {
        this._error.next(new PershingError(errorMessage, 'contentComponent', errorCode));
    }
    ngOnDestroy() {
        console.log('destroying content management component');
        if (this.contentSubscription) {
            this.contentSubscription.unsubscribe();
        }
    }
    backToPreviousRoute() {
        let backUrl;
        if (localStorage.getItem('lastUrlBeforeDisc') == null) {
            backUrl = this.homePage;
        }
        else if (localStorage.getItem('previousUrl') === localStorage.getItem('lastUrlBeforeDisc')) {
            backUrl = localStorage.getItem('previousUrl');
        }
        else {
            backUrl = localStorage.getItem('lastUrlBeforeDisc');
        }
        let detailForEvent = {
            'gotoPage': backUrl,
            'gotoParams': null
        };
        if (backUrl.includes('?')) {
            const queryString = backUrl.substring(backUrl.indexOf('?') + 1);
            const urlSearchParams = new URLSearchParams(queryString);
            const params = Object.fromEntries(urlSearchParams.entries());
            const page = backUrl.substring(0, backUrl.indexOf('?'));
            detailForEvent = {
                'gotoPage': page,
                'gotoParams': params
            };
        }
        document.dispatchEvent(new CustomEvent('portal.gotoview', {
            detail: detailForEvent
        }));
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ContentManagementComponent, deps: [{ token: i1.PershingTranslationService }, { token: i1.PershingDecimalFormatPipe }, { token: i0.NgZone }, { token: i1.LogService }, { token: i1$3.DomSanitizer }, { token: i1.ServiceRouter }, { token: i4$1.TranslateService }, { token: i1.PermissionCheckerService }, { token: i4.Location }, { token: 'AppSettings', optional: true }, { token: i5.Router, optional: true }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ContentManagementComponent, selector: "content-management", inputs: { communityName: "communityName", articleId: "articleId", isHeaderRequired: "isHeaderRequired", isFooter: "isFooter", entitlement: "entitlement", doNotOverrideCommunityName: "doNotOverrideCommunityName" }, outputs: { hasContent: "hasContent" }, viewQueries: [{ propertyName: "contentDivRef", first: true, predicate: ["contentDiv"], descendants: true }], ngImport: i0, template: "<ng-container *ngIf=\"!isSitebuilderContent\">\n    <header *ngIf=\"isEntitledforView && hasData\" [ngClass] = \"{'portlet-topper': isAda && !isFooter && isHeaderRequired }\">\n        <div class=\"cm-Title_Container  margin-bottom-10 {{articleId}}\" *ngIf=\"isHeaderRequired\" >\n            <h2 class=\"cm-Title\">{{ titleId | translate }}</h2>\n            <ng-container *ngIf=\"showBackButton\"> \n                <form class=\"cm-BackLink_Container margin-bottom-0\" >\n                    <a class=\"icon-chevron-left cm-BackLink\" href=\"javascript:void(0);\" (click)=\"backToPreviousRoute()\">\n                    Back\n                    </a>\n                </form>\n            </ng-container>\n        </div>\n    </header>\n    <div #contentDiv *ngIf=\"isEntitledforView\" class=\"cm-Content {{articleId}}\"></div>\n</ng-container>\n\n<ng-container *ngIf=\"isSitebuilderContent\">\n    <cms-text [contentName]=\"articleId\" [showContentHeader]=\"showHeader\"> </cms-text>\n</ng-container> \n", styles: [":host ::ng-deep .listalign{list-style-type:none!important;margin:0!important;padding:0!important;display:flex!important}\n"], dependencies: [{ kind: "directive", type: i6.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i6.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CMSTextComponent, selector: "cms-text", inputs: ["siteId", "stagingSiteId", "contentPath", "stagingContentPath", "contentName", "titleContentName", "contentHierarchy", "contentVersion", "componentId", "userId", "isStaging", "isEditOnlyMode", "deleteContentEventEmitter", "isComingFromCreatedSite", "cmsLocale", "showContentHeader"], outputs: ["onPreviewContent"] }, { kind: "pipe", type: i4$1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ContentManagementComponent, decorators: [{
            type: Component,
            args: [{ selector: 'content-management', template: "<ng-container *ngIf=\"!isSitebuilderContent\">\n    <header *ngIf=\"isEntitledforView && hasData\" [ngClass] = \"{'portlet-topper': isAda && !isFooter && isHeaderRequired }\">\n        <div class=\"cm-Title_Container  margin-bottom-10 {{articleId}}\" *ngIf=\"isHeaderRequired\" >\n            <h2 class=\"cm-Title\">{{ titleId | translate }}</h2>\n            <ng-container *ngIf=\"showBackButton\"> \n                <form class=\"cm-BackLink_Container margin-bottom-0\" >\n                    <a class=\"icon-chevron-left cm-BackLink\" href=\"javascript:void(0);\" (click)=\"backToPreviousRoute()\">\n                    Back\n                    </a>\n                </form>\n            </ng-container>\n        </div>\n    </header>\n    <div #contentDiv *ngIf=\"isEntitledforView\" class=\"cm-Content {{articleId}}\"></div>\n</ng-container>\n\n<ng-container *ngIf=\"isSitebuilderContent\">\n    <cms-text [contentName]=\"articleId\" [showContentHeader]=\"showHeader\"> </cms-text>\n</ng-container> \n", styles: [":host ::ng-deep .listalign{list-style-type:none!important;margin:0!important;padding:0!important;display:flex!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.PershingTranslationService }, { type: i1.PershingDecimalFormatPipe }, { type: i0.NgZone }, { type: i1.LogService }, { type: i1$3.DomSanitizer }, { type: i1.ServiceRouter }, { type: i4$1.TranslateService }, { type: i1.PermissionCheckerService }, { type: i4.Location }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['AppSettings']
                }] }, { type: i5.Router, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { communityName: [{
                type: Input
            }], articleId: [{
                type: Input
            }], isHeaderRequired: [{
                type: Input
            }], isFooter: [{
                type: Input
            }], entitlement: [{
                type: Input
            }], doNotOverrideCommunityName: [{
                type: Input
            }], hasContent: [{
                type: Output
            }], contentDivRef: [{
                type: ViewChild,
                args: ['contentDiv', { static: false }]
            }] } });

class ImageContentComponent {
    contentservice;
    translationService;
    appSettings;
    contentName; // aka file name, internal name, article id. ex: ABOUT_US
    themeType = 'conservative';
    imageSrc = '';
    imageFormat = 'data:image/png;base64, ';
    unsubscribe = new Subject();
    defaultLang = 'en';
    isStaging = true; // Whether image is fetched from staging or publish.
    siteDomain = ''; // To derive content path;
    imageClass = '';
    hierarchy; // should be comma separated string
    isSitebuilderCMSEnabled = false;
    // constants
    DESKTOP = 'desktop';
    DESKTOP_CONTENT_NAME = 'carousel-desktop.png';
    DESKTOP_IMAGE_CLASS = 'ws-Image';
    TABLET = 'tablet';
    TABLET_CONTENT_NAME = 'carousel-tablet.png';
    TABLET_IMAGE_CLASS = 'ws-Image-tablet';
    MOBILE = 'mobile';
    MOBILE_CONTENT_NAME = 'carousel-mobile.png';
    MOBILE_IMAGE_CLASS = 'ws-Image-mobile';
    constructor(contentservice, translationService, appSettings) {
        this.contentservice = contentservice;
        this.translationService = translationService;
        this.appSettings = appSettings;
    }
    ngOnInit() {
        // The domain will either be the targeted preview domain (e.g. used in Site Builder tool context) or itself.
        this.siteDomain = !!this.appSettings.previewSite ? this.appSettings.previewSite : this.appSettings.ibdConfigMap.URL;
        // Always use staging for preview otherwise, it should depends on the site itself.
        this.isStaging = !!this.appSettings.previewSite ? true : this.appSettings.ibdConfigMap.staging;
        this.isSitebuilderCMSEnabled = this.appSettings.isSitebuilderCMSEnabled;
        this.initFullImageSrcUrl();
    }
    initFullImageSrcUrl() {
        // e.g. https://staging-previewx.test.netxinvestor.com/test-netxinvestor-webcontent-svc-uat-app/webcontent/imageContentDirect/
        //      sitebuilder-site/sitebuilder-site?contentName=carousel.png&isStaging=true&isComingFromCreatedSite=true&
        //      contentPath=retail/previewx-test-netxinvestor-com/conservative/en
        if (this.appSettings.deviceType === this.DESKTOP) {
            this.contentName = this.DESKTOP_CONTENT_NAME;
            this.imageClass = this.DESKTOP_IMAGE_CLASS;
        }
        else if (this.appSettings.deviceType === this.TABLET) {
            this.contentName = this.TABLET_CONTENT_NAME;
            this.imageClass = this.TABLET_IMAGE_CLASS;
        }
        else if (this.appSettings.deviceType === this.MOBILE) {
            this.contentName = this.MOBILE_CONTENT_NAME;
            this.imageClass = this.MOBILE_IMAGE_CLASS;
        }
        if (this.isSitebuilderCMSEnabled) {
            this.initTheHierarchySoItFallBackToPreviewSite();
            this.imageSrc = this.contentservice.baseUrl + '/imageContentDirect/' + this.appSettings.cms.siteId + '/' + this.appSettings.cms.stagingSiteId +
                '?contentName=' + this.contentName + '&isStaging=' + this.isStaging + '&isComingFromCreatedSite=' + this.appSettings.isSitebuilder +
                '&contentPath=' + this.getResolvedContentPath(this.siteDomain) + '&hierarchy=' + this.hierarchy;
        }
        else {
            this.imageSrc = this.appSettings.siteCdnUrl + '/images/' + this.contentName;
        }
    }
    /**
     * Set the preview site to be top of the hierarchy. So it fallback to getting image from preview site if it can't get any for the site that it want to preview
     */
    initTheHierarchySoItFallBackToPreviewSite() {
        let urlOfSiteThatWeUseForPreview = !!this.appSettings.previewSite ? this.appSettings.ibdConfigMap.URL : '';
        this.hierarchy = this.getResolvedContentPath(urlOfSiteThatWeUseForPreview);
    }
    getImageContent() {
        this.contentservice.getImageContent(this.appSettings.cms.siteId, this.appSettings.cms.stagingSiteId, this.contentName, this.getResolvedContentPath(this.siteDomain), [], this.appSettings.ibdConfigMap.staging, this.appSettings.isSitebuilder).pipe(takeUntil(this.unsubscribe)).subscribe(rsp => {
            if (rsp && rsp.errorCode === 0 && !!rsp.response) {
                this.imageSrc = this.imageFormat + rsp.response;
            }
        });
    }
    getResolvedContentPath(siteUrl) {
        // Path for Crafter consists of platform + resolved site domain (sub domain & domain) + theme + language.
        // e.g. for prodution site:  https://pncinvestments.netxinvestor.com/ 
        //    Domain:  pncinvestments.netxinvestor.com
        //    Resolved prod content path:  retail/pncinvestments-netxinvestor-com/conservative/en
        //    Resolved staging content path:  retail/pncinvestments-qa-netxinvestor-com/conservative/en
        // Also currently we use one image for all languages - should change needed, replace it with this.translationService.userLang.
        if (!siteUrl)
            return '';
        return this.appSettings.platform + '/' + this.domainToPath(siteUrl) + '/' + this.themeType + '/' + this.defaultLang;
    }
    domainToPath(fullDomain) {
        let path = '';
        if (!!fullDomain) {
            // Remove prefix 'staging-' and convert all dot to dash.
            let domain = fullDomain.indexOf('?') > 0 ? fullDomain.slice(0, fullDomain.indexOf('?')) : fullDomain;
            path = domain.replace('staging-', '').replace(/\./g, '-');
        }
        return path;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ImageContentComponent, deps: [{ token: ContentStudioService }, { token: i1.PershingTranslationService }, { token: 'AppSettings', optional: true }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ImageContentComponent, selector: "image-content", inputs: { contentName: "contentName" }, ngImport: i0, template: "<div class=\"cms-Image_ContainerNoEdit\">\n    <img [ngClass]=\"imageClass\" [src]=\"imageSrc\" alt=\"Welcome Image\">\n</div>", dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ImageContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'image-content', template: "<div class=\"cms-Image_ContainerNoEdit\">\n    <img [ngClass]=\"imageClass\" [src]=\"imageSrc\" alt=\"Welcome Image\">\n</div>" }]
        }], ctorParameters: function () { return [{ type: ContentStudioService }, { type: i1.PershingTranslationService }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['AppSettings']
                }] }]; }, propDecorators: { contentName: [{
                type: Input
            }] } });

class DownloadExcelComponent {
    translationService;
    asofTime;
    downloadOption = new EventEmitter();
    constructor(translationService) {
        this.translationService = translationService;
        this.translationService.addTranslationFolder('@pershing/nxi-ng-common', 'node_modules/@pershing/nxi-ng-common/lib');
    }
    download(dwval) {
        this.downloadOption.emit(dwval);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DownloadExcelComponent, deps: [{ token: i1.PershingTranslationService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DownloadExcelComponent, selector: "download-excel", inputs: { asofTime: "asofTime" }, outputs: { downloadOption: "downloadOption" }, ngImport: i0, template: "<button mat-icon-button class=\"text-link\" [matMenuTriggerFor]=\"menu\" role=\"button\" attr.aria-label=\"{{'DOWNLOADEXCEL.DOWNLOAD' | translate}}\">\n    <span class=\"large fas fa-download\"></span>\n</button>\n<mat-menu #menu=\"matMenu\" [hasBackdrop]=\"true\" class=\"fw-Download\">\n<button mat-menu-item (click)=\"download('print')\" role=\"menuitem\" attr.aria-label=\"{{'DOWNLOADEXCEL.PRINT' | translate}}\"><em class=\"fal fa-print margin-right-10\"></em>{{'DOWNLOADEXCEL.PRINT' | translate}}</button>\n<button mat-menu-item (click)=\"download('exporttoexcel')\" role=\"menuitem\" attr.aria-label=\"{{'DOWNLOADEXCEL.EXPORTTOEXCEL' | translate}}\"><em class=\"fal fa-file-excel margin-right-10\"></em>{{'DOWNLOADEXCEL.EXPORTTOEXCEL' | translate}}</button>\n</mat-menu>\n", styles: [".balance-download .mat-card-content li{list-style-type:none}\n"], dependencies: [{ kind: "component", type: i7.MatLegacyButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i3.MatLegacyMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "component", type: i3.MatLegacyMenuItem, selector: "[mat-menu-item]", inputs: ["disabled", "disableRipple"], exportAs: ["matMenuItem"] }, { kind: "directive", type: i3.MatLegacyMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "pipe", type: i4$1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DownloadExcelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'download-excel', template: "<button mat-icon-button class=\"text-link\" [matMenuTriggerFor]=\"menu\" role=\"button\" attr.aria-label=\"{{'DOWNLOADEXCEL.DOWNLOAD' | translate}}\">\n    <span class=\"large fas fa-download\"></span>\n</button>\n<mat-menu #menu=\"matMenu\" [hasBackdrop]=\"true\" class=\"fw-Download\">\n<button mat-menu-item (click)=\"download('print')\" role=\"menuitem\" attr.aria-label=\"{{'DOWNLOADEXCEL.PRINT' | translate}}\"><em class=\"fal fa-print margin-right-10\"></em>{{'DOWNLOADEXCEL.PRINT' | translate}}</button>\n<button mat-menu-item (click)=\"download('exporttoexcel')\" role=\"menuitem\" attr.aria-label=\"{{'DOWNLOADEXCEL.EXPORTTOEXCEL' | translate}}\"><em class=\"fal fa-file-excel margin-right-10\"></em>{{'DOWNLOADEXCEL.EXPORTTOEXCEL' | translate}}</button>\n</mat-menu>\n", styles: [".balance-download .mat-card-content li{list-style-type:none}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.PershingTranslationService }]; }, propDecorators: { asofTime: [{
                type: Input
            }], downloadOption: [{
                type: Output
            }] } });

class ComponentTitleComponent {
    themeType;
    // @input theme has to be removed
    theme = '';
    portletTitle = '';
    // Page specific - per Ed:  NS-4242...For example in the Conservative theme,
    // the titles and borders are enabled for some portlets but not enabled for most grids.
    showTitle = true;
    bordersStyles = '';
    set showBorders(showBorders) {
        this.bordersStyles = !!showBorders && showBorders ? 'portlet-topper' : '';
    }
    // Override showBorder with whatever styles passed in
    set customBorders(customBorders) {
        this.bordersStyles = !!customBorders ? customBorders : '';
    }
    constructor(appSettings) {
        if (appSettings.themeType && appSettings.themeType === 'ada') {
            this.themeType = 'ada';
        }
        else {
            this.themeType = 'standard';
        }
    }
    ngOnInit() {
        //Intentionally empty override
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ComponentTitleComponent, deps: [{ token: 'AppSettings', optional: true }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ComponentTitleComponent, selector: "component-title", inputs: { theme: "theme", portletTitle: "portletTitle", showTitle: "showTitle", showBorders: "showBorders", customBorders: "customBorders" }, ngImport: i0, template: "<ng-container *ngIf=\"!!themeType && themeType === 'standard'\">\n    <header class=\"{{bordersStyles}}\">\n        <ng-template [ngIf]=\"showTitle\">\n            <h1 class=\"portlet-title\">\n                <span class=\"portlet-title-text\">{{ portletTitle | translate }}</span>\n            </h1>\n        </ng-template>\n    </header>\n</ng-container>\n\n<ng-container *ngIf=\"!!themeType && themeType === 'ada'\">\n    <header class=\"{{bordersStyles}}\">\n        <ng-template [ngIf]=\"showTitle\">\n            <h2 class=\"portlet-title\">\n                <span class=\"portlet-title-text\">{{ portletTitle | translate }}</span>\n            </h2>\n        </ng-template>\n    </header>\n</ng-container>", dependencies: [{ kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i4$1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ComponentTitleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'component-title', template: "<ng-container *ngIf=\"!!themeType && themeType === 'standard'\">\n    <header class=\"{{bordersStyles}}\">\n        <ng-template [ngIf]=\"showTitle\">\n            <h1 class=\"portlet-title\">\n                <span class=\"portlet-title-text\">{{ portletTitle | translate }}</span>\n            </h1>\n        </ng-template>\n    </header>\n</ng-container>\n\n<ng-container *ngIf=\"!!themeType && themeType === 'ada'\">\n    <header class=\"{{bordersStyles}}\">\n        <ng-template [ngIf]=\"showTitle\">\n            <h2 class=\"portlet-title\">\n                <span class=\"portlet-title-text\">{{ portletTitle | translate }}</span>\n            </h2>\n        </ng-template>\n    </header>\n</ng-container>" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['AppSettings']
                }] }]; }, propDecorators: { theme: [{
                type: Input
            }], portletTitle: [{
                type: Input
            }], showTitle: [{
                type: Input
            }], showBorders: [{
                type: Input
            }], customBorders: [{
                type: Input
            }] } });

class NXIRestServiceDefinition {
    static instance;
    uri = 'services/netxclient.rest-service';
    version = 'v1';
    family = 'netxinvestor';
    appName = 'rest-service';
    serviceName = 'app';
    mnemonic = 'nxc';
    static getInstance() {
        if (!NXIRestServiceDefinition.instance) {
            NXIRestServiceDefinition.instance = new NXIRestServiceDefinition();
        }
        return NXIRestServiceDefinition.instance;
    }
    constructor() { }
}

class NxiIconsService {
    http;
    logService;
    serviceRouter;
    serviceUrl;
    constructor(http, logService, serviceRouter) {
        this.http = http;
        this.logService = logService;
        this.serviceRouter = serviceRouter;
        logService.info('IconsService : constructor Initializing');
        this.serviceUrl = this.serviceRouter.getServiceRouteURL(NXIRestServiceDefinition.getInstance());
    }
    getMessages() {
        return this.http.get(this.serviceUrl + '/portfolio/messages');
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NxiIconsService, deps: [{ token: i1$1.HttpClient }, { token: i1.LogService }, { token: i1.ServiceRouter }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NxiIconsService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NxiIconsService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: i1.LogService }, { type: i1.ServiceRouter }]; } });

class AccountDisplayPipe {
    appDataStore;
    accountList;
    acctdisplayformat;
    constructor(appDataStore) {
        this.appDataStore = appDataStore;
    }
    transform(accountNumber) {
        this.accountList = this.appDataStore.get('ACCOUNTS_LIST');
        let acct;
        if (this.accountList) {
            acct = this.accountList.find(c => c.acctNo === accountNumber);
        }
        if (acct) {
            if (acct.acctNick) {
                this.acctdisplayformat = acct.acctNick + '   x' + acct.displayLabel.substr(acct.displayLabel.length - 4);
            }
            else {
                this.acctdisplayformat = acct.maskedAcctNo;
            }
            return this.acctdisplayformat;
        }
        else {
            return accountNumber;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AccountDisplayPipe, deps: [{ token: i1.AppDataStore }], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: AccountDisplayPipe, name: "accountDisplayPipe" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AccountDisplayPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'accountDisplayPipe'
                }]
        }], ctorParameters: function () { return [{ type: i1.AppDataStore }]; } });

class NXIGridExportServiceDefinition {
    static instance = null;
    family = 'netxinvestor';
    appName = 'export-svc';
    serviceName = 'app';
    uri = 'export';
    version = 'v1';
    mnemonic = 'nxp';
    static getInstance() {
        if (!NXIGridExportServiceDefinition.instance) {
            NXIGridExportServiceDefinition.instance = new NXIGridExportServiceDefinition();
        }
        return NXIGridExportServiceDefinition.instance;
    }
    constructor() { }
}

const SERVICE_CALL_TIMEOUT = 300000;
const COMMON_DOWNLOAD_MESSAGE = 'Requested report is being generated and it will be available shortly in the downloads folder.';
const COMMON_DOWNLOAD_ACTION_MESSAGE = '';
class GridExportService {
    http;
    logService;
    serviceRouter;
    _snackBar;
    dialog;
    exportServiceUrl;
    settingsDetailsServiceUrl;
    constructor(http, logService, serviceRouter, _snackBar, dialog) {
        this.http = http;
        this.logService = logService;
        this.serviceRouter = serviceRouter;
        this._snackBar = _snackBar;
        this.dialog = dialog;
        logService.info('GridExportService : constructor Initializing');
        this.exportServiceUrl = this.serviceRouter.getServiceRouteURL(NXIGridExportServiceDefinition.getInstance(), { ignoreOptions: { serviceVersion: true } });
    }
    initiateExportCallWithJSONData(jsonString, exportConfig, downloadExtension, fileName) {
        let headerObj = new HttpHeaders();
        headerObj.append('Content-Type', 'application/x-www-form-urlencoded');
        let params = new HttpParams();
        params = params.append('gridJSONData', this.encodeGridData(jsonString, exportConfig));
        params = params.append('exportConfig', JSON.stringify(exportConfig));
        let url = '';
        if (downloadExtension === 'pdf') {
            url = this.exportServiceUrl + '/gridjsondatatopdf';
        }
        else if (downloadExtension === 'xlsx') {
            url = this.exportServiceUrl + '/gridjsondatatoexcel';
        }
        this.http
            .post(url, params, {
            headers: headerObj,
            responseType: 'blob',
            observe: 'response',
        })
            .pipe(timeout(SERVICE_CALL_TIMEOUT))
            .subscribe((resp) => {
            this.handleExportResponse(resp, exportConfig, downloadExtension, fileName);
        }, (error) => {
            this.openErrorDialog();
            this.logService.error('ERROR: GridExportService - initiateExportCall : ', error);
        });
    }
    encodeGridData(gridData, exportConfig) {
        let returnData = gridData;
        if (exportConfig &&
            exportConfig['dataEncodedWithBase64'] &&
            typeof exportConfig['dataEncodedWithBase64'] === 'string') {
            let base64Encode = exportConfig['dataEncodedWithBase64'].toUpperCase();
            if (base64Encode === 'YES' || base64Encode === 'TRUE') {
                returnData = btoa(gridData);
            }
        }
        else {
            returnData = btoa(gridData);
        }
        return returnData;
    }
    handleExportResponse(resp, exportConfig, downloadExtension, fileName) {
        this._snackBar.dismiss();
        this.logService.log('Success: GridExportService - initiateExportCall');
        let downloadElement = document.createElement('a');
        downloadElement.setAttribute('href', window.URL.createObjectURL(resp.body));
        downloadElement.setAttribute('download', this.getFileName(resp.headers, fileName, downloadExtension, exportConfig));
        downloadElement.click();
    }
    getFileName(headers, fileName, downloadExtension, exportConfig) {
        let returnfileName = this.contentDispositionFileName(headers);
        if (returnfileName === null) {
            if (fileName === undefined || fileName === null || fileName === '') {
                if (exportConfig && exportConfig['title']) {
                    returnfileName = exportConfig['title'];
                    if (exportConfig['contextValue']) {
                        returnfileName =
                            returnfileName + '_' + exportConfig['contextValue'];
                    }
                }
                else {
                    returnfileName = 'exportfile';
                }
            }
            else {
                returnfileName = fileName;
            }
            returnfileName = returnfileName.replace(/ /g, '+');
            returnfileName += '.' + downloadExtension;
        }
        return returnfileName;
    }
    contentDispositionFileName(headers) {
        let fileName = null;
        if (headers &&
            headers.get('Content-Disposition') !== null &&
            headers.get('Content-Disposition') !== undefined) {
            headers
                .get('Content-Disposition')
                .split(';')
                .forEach((i) => {
                if (i.includes('filename') && i.split('=').length === 2) {
                    fileName = i.split('=')[1].replace(/"/g, '');
                }
            });
        }
        return fileName;
    }
    openErrorDialog() {
        this._snackBar.dismiss();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: GridExportService, deps: [{ token: i1$1.HttpClient }, { token: i1.LogService }, { token: i1.ServiceRouter }, { token: i3$1.MatLegacySnackBar }, { token: i1$2.MatLegacyDialog }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: GridExportService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: GridExportService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: i1.LogService }, { type: i1.ServiceRouter }, { type: i3$1.MatLegacySnackBar }, { type: i1$2.MatLegacyDialog }]; } });

class PortalNavigationService {
    router;
    authorizationService;
    location;
    contextService;
    publicMenuConfigObservable$;
    privateMenuConfigObservable$;
    deviceType = 'desktop';
    parentPageId;
    childPageId;
    grandChildPageId;
    fourthChildPageId;
    currentUrl;
    _parentPage = new BehaviorSubject(undefined);
    _childPage = new BehaviorSubject(undefined);
    _grandChildPage = new BehaviorSubject(undefined);
    _fourthChildPage = new BehaviorSubject(undefined);
    queryParams;
    menuItems = [];
    themeType;
    isModernTheme = false;
    constructor(router, authorizationService, location, contextService, appSettings) {
        this.router = router;
        this.authorizationService = authorizationService;
        this.location = location;
        this.contextService = contextService;
        this.deviceType = appSettings.deviceType;
        let url = this.location.path(false);
        this.setCurrentUrl(url);
        this.location.subscribe(data => {
            let currenturl = data.url;
            if (currenturl && currenturl.indexOf('!') !== -1) {
                return;
            }
            this.setCurrentUrl(currenturl);
            this.setPageFromUrl(currenturl);
        });
        this.themeType = appSettings.themeType;
        this.isModernTheme = appSettings.isModernTheme;
    }
    getComingSoonMsgInd() {
        // Not needed for NXI
    }
    setComingSoonMsgInd() {
        // Not needed for NXI
    }
    trimQueryParams(url) {
        if (url.indexOf('?') !== -1) {
            url = url.substr(0, url.indexOf('?'));
        }
        return url;
    }
    getChildPageId() {
        return this.childPageId;
    }
    getChildPageName(url) {
        url = this.trimQueryParams(url);
        let urlArray = url.split('/');
        if (urlArray[urlArray.length - 1].split('?').length > 1) {
            urlArray[urlArray.length - 1] = urlArray[urlArray.length - 1].split('?')[0];
        }
        else if (urlArray[urlArray.length - 1].split('#').length > 1) {
            urlArray[urlArray.length - 1] = urlArray[urlArray.length - 1].split('#')[0];
        }
        else if (urlArray[urlArray.length - 1].split(';').length > 1) {
            urlArray[urlArray.length - 1] = urlArray[urlArray.length - 1].split(';')[0];
        }
        let childPageId = '';
        if (urlArray[3] !== undefined) {
            childPageId = urlArray[3];
            if (childPageId !== undefined || childPageId.indexOf('secondary') !== -1) {
                childPageId = childPageId.replace('(secondary:', '').replace(')', '');
                return childPageId;
            }
        }
        return childPageId;
    }
    getMenuConfigurations() {
        // Should be remove from pershing core.
        // This is not applicable with new MFE as menu is already part of portal config.
        return of({});
    }
    getDeviceType() {
        return this.deviceType;
    }
    getParentPageId() {
        return this.parentPageId;
    }
    getGroupName() {
        let groupName = 'nxi';
        let url = this.location.path(false);
        let urlArray = url.split('/');
        if (urlArray[2] === 'disclosure') {
            groupName = 'nxi/disclosure';
            return groupName;
        }
        else {
            return groupName;
        }
    }
    checkIsTitle(page) {
        for (let i = 0; i < page.length; i++) {
            if (page[i].istitle === undefined && (this.deviceType !== 'mobile' || page[i].showdefault)) {
                return page[i].id;
            }
        }
        return '';
    }
    handleNavigation(navigation) {
        let groupname = this.getGroupName();
        let initRes;
        let isSamePageNavigation = false;
        if (navigation.fourthchildPage) {
            initRes = this._initForthChildNavigation(navigation);
        }
        else if (navigation.grandchildPage) {
            initRes = this._initGrandchildNavigation(navigation);
        }
        else if (navigation.childPage) {
            initRes = this._initChildNavigation(navigation);
        }
        else {
            initRes = this._initAllNavigation(navigation);
        }
        document.dispatchEvent(new CustomEvent('portal.browserTitleValue', {
            detail: {
                'titleValue': initRes.titleValue,
                'pageIdValue': initRes.pageIdValue
            }
        }));
        /**  will publish the page navigated only if route it successful i.e router response is true
         *  else if router response is false will navigate to home page(default page)
         */
        let queryString = this._getQueryString(this.contextService.getRouteContext(), this.appendQueryForEdocs(initRes.args));
        let routeArgs = [];
        if (initRes.addReloadParam) {
            let reloadParam = { reload: (new Date).getTime() };
            routeArgs = [groupname, ...initRes.args, reloadParam];
        }
        else {
            routeArgs = [groupname, ...initRes.args];
        }
        isSamePageNavigation = location.pathname.includes(routeArgs.join('/'));
        console.log('NavigationService Route Args ', routeArgs);
        if (Object.keys(queryString).length > 0) {
            this.router.navigate(routeArgs, { queryParams: queryString }).then(response => {
                this.handleNavResponse(response, navigation, groupname, initRes.args, isSamePageNavigation, queryString);
            });
        }
        else {
            this.router.navigate(routeArgs).then(response => {
                this.handleNavResponse(response, navigation, groupname, initRes.args, isSamePageNavigation);
            });
        }
    }
    haveModChildPage() {
        let isModChildPage = false;
        // Refresh will not be required if the research pages
        // does not have any MOD child pages
        // Eg: For some site, only rateboard will be available under 'Research'
        // In the case, refresh will not be required
        if (this.authorizationService.isEntitled('MOD_MARKETS || MOD_QUOTES_NEWS || MOD_TOOLS')) {
            isModChildPage = true;
        }
        return isModChildPage;
    }
    appendQueryForEdocs(args) {
        let queryString;
        if (args[args.length - 1] === 'statementsreports') {
            queryString = { viewId: 'stmt' };
        }
        else if (args[args.length - 1] === 'tradeconfirmations') {
            queryString = { viewId: 'conf' };
        }
        else if (args[args.length - 1] === 'taxdocuments') {
            queryString = { viewId: 'tax' };
        }
        else if (args[args.length - 1] === 'notifications') {
            queryString = { viewId: 'addl' };
        }
        return queryString;
    }
    handleNavResponse(response, navigation, groupname, args, isSamePageNavigation, queryString) {
        if (response === true) {
            // successful navigation
            this.publishNavigation(navigation);
        }
        else if (response === false) {
            if (this.parentPageId !== 'home') {
                let HOME_PAGE = { 'id': 'home', 'name': 'Home' };
                this.handleNavigation(HOME_PAGE);
            }
        }
        else {
            isSamePageNavigation = true;
        }
        if (isSamePageNavigation) {
            // while clicking or navigating to route that is already active
            let reloadParam = { reload: (new Date).getTime() };
            if (queryString) {
                this.router.navigate(['nxi', 'dummy', 'refresh'], { skipLocationChange: true }).then(response1 => {
                    this.router.navigate([groupname, ...args, reloadParam], { queryParams: queryString });
                    console.log('Refresh same view with querystring ', response1);
                });
            }
            else {
                this.router.navigate(['nxi', 'dummy', 'refresh'], { skipLocationChange: true }).then(response1 => {
                    this.router.navigate([groupname, ...args, reloadParam]);
                    console.log('Refresh same view without querystring ', response1);
                });
            }
        }
    }
    publishNavigation(navigation) {
        if (navigation.fourthchildPage) {
            this.setFourthChildPageId(navigation.fourthchildPage.id);
            this.setFourthChildPage(navigation.fourthchildPage);
        }
        else if (navigation.grandchildPage) {
            this._setGrandChildPageAndId(navigation);
        }
        else if (navigation.childPage) {
            this._setChildPageAndId(navigation);
        }
        else {
            this._setAllPageAndId(navigation);
        }
    }
    setChildPageId(childId) {
        if (childId) {
            sessionStorage.setItem('nav_current_pageid', childId);
        }
        this.childPageId = childId;
    }
    setParentPageId(pageId) {
        if (pageId) {
            sessionStorage.setItem('nav_current_pageid', pageId);
        }
        this.parentPageId = pageId;
    }
    setParentPage(parentPage) {
        this._parentPage.next(parentPage);
    }
    getParentPage() {
        return this._parentPage.asObservable();
    }
    setChildPage(childpage) {
        this._childPage.next(childpage);
    }
    getChildPage() {
        return this._childPage.asObservable();
    }
    setGrandChildPageId(grandChildPageId) {
        if (grandChildPageId) {
            sessionStorage.setItem('nav_current_pageid', grandChildPageId);
        }
        this.grandChildPageId = grandChildPageId;
    }
    getGrandChildPageId() {
        return this.grandChildPageId;
    }
    setGrandChildPage(grandChildPage) {
        this._grandChildPage.next(grandChildPage);
    }
    getGrandChildPage() {
        return this._grandChildPage.asObservable();
    }
    setFourthChildPageId(fourthChildPageId) {
        if (fourthChildPageId) {
            sessionStorage.setItem('nav_current_pageid', fourthChildPageId);
        }
        this.fourthChildPageId = fourthChildPageId;
    }
    getFourthChildPageId() {
        return this.fourthChildPageId;
    }
    setFourthChildPage(fourthChildPage) {
        this._fourthChildPage.next(fourthChildPage);
    }
    getFourthChildPage() {
        return this._fourthChildPage.asObservable();
    }
    setQueryParams(url) {
        let params = this.parseQueryString(url);
        this.queryParams = params;
    }
    parseQueryString(url) {
        let params = {}, queries, temp, i, l;
        if (url.indexOf('?') !== -1) {
            let queryString = url.substring(url.indexOf('?') + 1, url.length + 1);
            // Split into key/value pairs
            queries = queryString.split('&');
            // Convert the array of strings into an object
            for (i = 0, l = queries.length; i < l; i++) {
                temp = queries[i].split('=');
                params[temp[0]] = temp[1];
            }
        }
        return params;
    }
    getQueryParams() {
        return this.queryParams;
    }
    handleNavigationWithDomain(domain) {
        // Not needed for NXI
    }
    setCurrentUrl(url) {
        this.currentUrl = url;
    }
    getCurrentUrl() {
        return this.currentUrl;
    }
    /**
     * Implemented for supporting GOTO feature
     * Sets the passed domain and value in the contextservice
     * get the qParam from contextservice
     * Navigates to targetUri passed with/without qparam
     * @param domain
     * @param value
     * @param targetUri - should contain
     * the full page uri wiht groupname
     * eg. for market page setPageFromUrl('/nxi/research/markets/usmarkets')
     */
    setContextAndNavigate(domain, domainvalue, targetUriInput) {
        let targetUri = this._cleanUri(targetUriInput);
        if (targetUri) {
            this.router.events.subscribe((url) => {
                if (url.url) {
                    this.currentUrl = url.url;
                }
            });
            console.log('current url value --- ' + this.currentUrl);
            this.setCurrentUrl(targetUri);
            this.setPageFromUrl(targetUri);
            // Set context.
            if (domain && domainvalue) {
                this.contextService.setDomainContext(domain, domainvalue);
            }
            // Navigate
            let pageReload = this.currentUrl.includes(targetUri) && !this.currentUrl.includes('?viewId');
            let qParams = {};
            // Append query for suppressed account.
            qParams = this._appendQueryForSuppressedAccount(this.contextService.getRouteContext(), qParams);
            // Append edoc query for a specific page to qParams.
            qParams = this._appendQueryForEdocsPages(targetUri.split('/'), qParams);
            return this._doNavigate(pageReload, targetUri, qParams);
        }
    }
    /**
     * The purpose of this is to set the selected menu for 1st and 2nd level based on the page uri.
     * In addition, the selected menu is also emitted so that the value is displayed to browser tab - consider refactor this.
     * Note on design/approach:  Current NXI, menu is directly fetched by this service where as MFE, menu list is part of portal config and is passed
     * into navigation component from host app.
     */
    setSelectedPageMenu(url, menuList) {
        this.menuItems = menuList;
        this.setPageFromUrl(url);
    }
    /**
     * Set the page object and page values from the url
     * @param url url - should start with the groupname. eg. for market page
     * setPageFromUrl('/nxi/research/markets/usmarkets')
     */
    setPageFromUrl(url) {
        let urlArray = this._splitUrlToArray(url);
        if (urlArray[2] === 'disclosure') {
            this.setParentPageId(urlArray[3]);
            this.setChildPageId(urlArray[4]);
            this.setGrandChildPageId(urlArray[5]);
        }
        else {
            this.setParentPageId(urlArray[2]);
            this.setChildPageId(urlArray[3]);
            this.setGrandChildPageId(urlArray[4]);
            this.setFourthChildPageId(urlArray[5]);
        }
        let pageId = this.childPageId;
        console.log('setPageFromUrl method--' + pageId);
        if (pageId) {
            console.log('setPageFromUrl method menuitem--' + this.menuItems);
            this._setPageFromPageId(pageId);
        }
        else {
            pageId = this.parentPageId;
            console.log('setPageFromUrl method else case --' + pageId);
            let result = this.menuItems.filter(menuItem => menuItem.id === pageId)[0];
            if (result) {
                this.setParentPage(result);
            }
        }
        document.dispatchEvent(new CustomEvent('portal.browserTitleValue', {
            detail: {
                'titleValue': pageId,
                'pageIdValue': pageId
            }
        }));
    }
    navigateOnContext() {
        // Not needed for NXI
    }
    navigateOnAction() {
        // Not needed for NXI
    }
    constructMyMenu() {
        // Not needed for NXI
    }
    // Refactor for handleNavigation
    _getQueryString(qParams, eDocsQueryString) {
        let queryString = {};
        if (qParams) {
            if (qParams instanceof Object) {
                queryString = qParams;
            }
            else {
                queryString = Object.assign({}, PershingHttpUtil.getJsonObjectFromQueryString(qParams));
            }
        }
        if (eDocsQueryString) {
            queryString = Object.assign(queryString, eDocsQueryString);
        }
        return queryString;
    }
    _initForthChildNavigation(navigation) {
        let res = { args: [], titleValue: '', pageIdValue: '', addReloadParam: false };
        res.args.push(this.parentPageId);
        res.args.push(this.childPageId);
        res.args.push(this.grandChildPageId);
        res.args.push(navigation.fourthchildPage.id);
        res.titleValue = navigation.fourthchildPage.name;
        res.pageIdValue = navigation.fourthchildPage.id;
        return res;
    }
    _initGrandchildNavigation(navigation) {
        let res = { args: [], titleValue: '', pageIdValue: '', addReloadParam: false };
        this.contextService.setRouteContext('');
        res.args.push((navigation.parentPage && navigation.parentPage.id) ? navigation.parentPage.id : this.parentPageId);
        res.args.push((navigation.childPage && navigation.childPage.id) ? navigation.childPage.id : this.childPageId);
        res.args.push(navigation.grandchildPage.id);
        if (navigation.grandchildPage.children && navigation.grandchildPage.children.length > 0) {
            res.titleValue = navigation.grandchildPage.children[0].name;
            res.pageIdValue = navigation.grandchildPage.children[0].id;
            res.args.push(navigation.grandchildPage.children[0].id);
        }
        return res;
    }
    _initChildNavigation(navigation) {
        let res = { args: [], titleValue: '', pageIdValue: '', addReloadParam: false };
        this.contextService.setRouteContext('');
        if (this.parentPageId === 'postlogin-security') {
            if (navigation.childPage.id === 'allcommunications' || navigation.childPage.id === 'settings') {
                this.parentPageId = 'communications';
            }
        }
        res.args.push((navigation.parentPage && navigation.parentPage.id) ? navigation.parentPage.id : this.parentPageId);
        res.args.push(navigation.childPage.id);
        if (!navigation.childPage.skipChildNav && navigation.childPage.children && navigation.childPage.children.length > 0) {
            res.args.push(this.checkIsTitle(navigation.childPage.children));
        }
        res.titleValue = navigation.childPage.name;
        res.pageIdValue = navigation.childPage.id;
        // Only for Mobile Navigation
        // Always re-render neworder view without any state
        // when clicked from navigation menu
        if (this.deviceType && this.deviceType === 'mobile') {
            if (navigation.childPage.id === 'neworder' && this.childPageId === 'neworder') {
                res.addReloadParam = true;
            }
        }
        return res;
    }
    _initAllNavigation(navigation) {
        let res = { args: [], titleValue: '', pageIdValue: '', addReloadParam: false };
        this.contextService.setRouteContext('');
        let pageId = navigation.parentPage.id;
        res.args.push(pageId);
        if (navigation.parentPage.children && navigation.parentPage.children.length > 0) {
            pageId = navigation.parentPage.children[0].id;
            res.args.push(pageId);
            let childPage = navigation.parentPage.children[0];
            if (childPage.children && childPage.children.length > 0) {
                res.args.push(this.checkIsTitle(childPage.children));
            }
        }
        if (navigation.parentPage.children.length > 0) {
            res.titleValue = navigation.parentPage.children[0].name;
            res.pageIdValue = navigation.parentPage.children[0].id;
        }
        else {
            res.titleValue = navigation.parentPage.id;
            res.pageIdValue = navigation.parentPage.id;
        }
        return res;
    }
    // Refactor for handleNavigation end
    // Refactor for publishNavigation
    _setGrandChildPageAndId(navigation) {
        this.setGrandChildPageId(navigation.grandchildPage.id);
        this.setGrandChildPage(navigation.grandchildPage);
        if (navigation.grandchildPage.children && navigation.grandchildPage.children.length > 0) {
            let fourthChild = navigation.grandchildPage.children[0];
            this.setFourthChildPageId(fourthChild.id);
            this.setFourthChildPage(fourthChild);
        }
    }
    _setChildPageAndId(navigation) {
        this.setGrandChildPage(undefined);
        this.setGrandChildPageId(undefined);
        if (navigation.parentPage) {
            this.setParentPageId(navigation.parentPage.id);
            this.setParentPage(navigation.parentPage);
        }
        this.setChildPageId(navigation.childPage.id);
        if (navigation.childPage.hideFromNavigation) {
            this.setGrandChildPage(navigation.childPage);
        }
        else {
            this.setChildPage(navigation.childPage);
        }
        // Update the first child  of childPage as grandchild if children  exist
        if (!navigation.childPage.skipChildNav && navigation.childPage.children && navigation.childPage.children.length > 0) {
            let firstChild = navigation.childPage.children[0];
            this.setGrandChildPageId(firstChild.id);
            this.setGrandChildPage(firstChild);
        }
    }
    _setAllPageAndId(navigation) {
        this.setParentPageId(navigation.parentPage.id);
        this.setParentPage(navigation.parentPage);
        this.setGrandChildPage(undefined);
        this.setGrandChildPageId(undefined);
        this.setChildPage(undefined);
        this.setChildPageId(undefined);
        if (navigation.parentPage.children && navigation.parentPage.children.length > 0) {
            let firstChild = navigation.parentPage.children[0];
            this.setChildPage(firstChild);
            this.setChildPageId(firstChild.id);
            if (firstChild.children && firstChild.children.length > 0) {
                let firstGrandChild = firstChild.children[0];
                this.setGrandChildPageId(firstGrandChild.id);
                this.setGrandChildPage(firstGrandChild);
            }
        }
    }
    // Refactor for publishNavigation ends.
    // Refactor for setContextAndNavigate.
    _cleanUri(targetUrl) {
        if (!!targetUrl) {
            if (targetUrl.split('#').length > 1) {
                targetUrl = targetUrl.split('#')[0];
            }
            if (targetUrl.split(';').length > 1) {
                targetUrl = targetUrl.split(';')[0];
            }
            return targetUrl;
        }
        else {
            return null;
        }
    }
    // for appending the viewId in query param for edoc
    _appendQueryForEdocsPages(args, qParams) {
        if (args[2] === 'communications') { // the args looks like ["", "nxi", "communications", "statementsreports"]
            let eDocsQueryString = this.appendQueryForEdocs(args);
            if (eDocsQueryString) {
                qParams = Object.assign(qParams, eDocsQueryString);
            }
        }
        return qParams;
    }
    _appendQueryForSuppressedAccount(qParamsaccoutsuppresd, qParams) {
        if (!!qParamsaccoutsuppresd && typeof qParamsaccoutsuppresd === 'string') {
            let qParamsaccouts = [];
            let accoutparam = '';
            let accountParamKey = '';
            if (qParamsaccoutsuppresd.indexOf('&') !== -1) {
                qParamsaccouts = qParamsaccoutsuppresd.split('&');
                qParamsaccouts.forEach(function (item) {
                    if (item.indexOf('=') !== -1 && item.split('=')[1].length >= 64) {
                        accoutparam = item.split('=')[1];
                        accountParamKey = item.split('=')[0];
                    }
                });
            }
            else if (qParamsaccoutsuppresd.indexOf('=') !== -1 && qParamsaccoutsuppresd.split('=')[1].length >= 64) {
                accoutparam = qParamsaccoutsuppresd.split('=')[1];
                accountParamKey = qParamsaccoutsuppresd.split('=')[0];
            }
            if (accoutparam) {
                qParams = PershingHttpUtil.getJsonObjectFromQueryString(qParamsaccoutsuppresd);
                delete qParams[accountParamKey];
            }
            else {
                qParams = PershingHttpUtil.getJsonObjectFromQueryString(qParamsaccoutsuppresd);
            }
        }
        return qParams;
    }
    _doNavigate(pageReload, targetUri, qParams) {
        if (pageReload) {
            // Reload same route - add a reload param to re-render the route
            let reloadParam = { reload: (new Date).getTime() };
            if (Object.keys(qParams).length !== 0) {
                return this.router.navigate(['nxi', 'dummy', 'refresh'], { skipLocationChange: true }).then(response1 => {
                    return this.router.navigate([targetUri, reloadParam], { queryParams: qParams, fragment: 'main-container' });
                });
            }
            else {
                return this.router.navigate(['nxi', 'dummy', 'refresh'], { skipLocationChange: true }).then(response1 => {
                    return this.router.navigate([targetUri, reloadParam], { fragment: 'main-container' });
                });
            }
        }
        else {
            if (Object.keys(qParams).length !== 0) {
                return this.router.navigate([targetUri], { queryParams: qParams, fragment: 'main-container' });
            }
            else {
                return this.router.navigate([targetUri], { fragment: 'main-container' });
            }
        }
    }
    // Refactor for setContextAndNavigate ends.    
    // Refactor for setPageFromUrl
    _splitUrlToArray(url) {
        let urlArray = url.split('/');
        if (urlArray[urlArray.length - 1].split('?').length > 1) {
            urlArray[urlArray.length - 1] = urlArray[urlArray.length - 1].split('?')[0];
        }
        else if (urlArray[urlArray.length - 1].split('#').length > 1) {
            urlArray[urlArray.length - 1] = urlArray[urlArray.length - 1].split('#')[0];
        }
        else if (urlArray[urlArray.length - 1].split(';').length > 1) {
            urlArray[urlArray.length - 1] = urlArray[urlArray.length - 1].split(';')[0];
        }
        if (urlArray[urlArray.length - 1].split(';').length > 1) {
            urlArray[urlArray.length - 1] = urlArray[urlArray.length - 1].split(';')[0];
        }
        return urlArray;
    }
    _setPageFromPageId(pageId) {
        for (let items of this.menuItems) {
            let result;
            for (let children of items.children) {
                if (children.id === pageId) {
                    result = children;
                    this.setParentPage(items);
                    this._processResult(result);
                    break;
                }
            }
            if (result !== undefined) {
                break;
            }
        }
    }
    _processResult(result) {
        if (result.children && result.children.length > 0) {
            this.setChildPage(result);
            let grandChildpage = result.children.filter(page => page.id === this.grandChildPageId)[0];
            if (!grandChildpage && !result.skipChildNav) {
                grandChildpage = result.children[0];
            }
            this.setGrandChildPage(grandChildpage);
            if (grandChildpage && grandChildpage.children && grandChildpage.children.length > 0) {
                let fourthChildpage = grandChildpage.children.filter(page => page.id === this.fourthChildPageId)[0];
                this.setFourthChildPage(fourthChildpage);
            }
        }
        else {
            if (result.hideFromNavigation) {
                this.setGrandChildPage(result);
            }
            else {
                this.setChildPage(result);
                this.setGrandChildPage(undefined);
            }
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PortalNavigationService, deps: [{ token: i5.Router }, { token: i1.PermissionCheckerService }, { token: i4.Location }, { token: i1.ContextService }, { token: 'AppSettings', optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PortalNavigationService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PortalNavigationService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i5.Router }, { type: i1.PermissionCheckerService }, { type: i4.Location }, { type: i1.ContextService }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['AppSettings']
                }] }]; } });

class NxiMobileService {
    http;
    logService;
    serviceRouter;
    isOpen = false;
    serviceUrl;
    isMobileMenuTabClickEvent = false;
    change = new EventEmitter();
    constructor(http, logService, serviceRouter) {
        this.http = http;
        this.logService = logService;
        this.serviceRouter = serviceRouter;
        logService.info('nxi mobile service : constructor Initializing');
        this.serviceUrl = this.serviceRouter.getServiceRouteURL(NXIRestServiceDefinition.getInstance());
    }
    toggle() {
        this.isOpen = !this.isOpen;
        this.change.emit(this.isOpen);
    }
    // This is to help sidenav Hostlistener to discern more granually if the click is from
    // within the 'Menu' tab itself.
    mobileMenuTabClickEvent(menuTabClick) {
        this.isMobileMenuTabClickEvent = menuTabClick;
    }
    checkExtendedHour() {
        return this.http.get(this.serviceUrl + '/trading-rest/check-extended-hour');
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NxiMobileService, deps: [{ token: i1$1.HttpClient }, { token: i1.LogService }, { token: i1.ServiceRouter }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NxiMobileService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NxiMobileService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: i1.LogService }, { type: i1.ServiceRouter }]; }, propDecorators: { change: [{
                type: Output
            }] } });

class ModernRateBoardServiceDefinition {
    static instance = null;
    uri = 'rateboard';
    version = 'v1';
    family = 'netxinvestor';
    appName = 'rateboard-svc';
    serviceName = 'app';
    mnemonic = 'nxc';
    static getInstance() {
        if (!ModernRateBoardServiceDefinition.instance) {
            ModernRateBoardServiceDefinition.instance = new ModernRateBoardServiceDefinition();
        }
        return ModernRateBoardServiceDefinition.instance;
    }
    constructor() { }
}

class RateBoardService {
    serviceRouter;
    http;
    logService;
    serviceUrl;
    ibd;
    rateBoardServiceUrl;
    fxRatesServiceError$ = new BehaviorSubject(null);
    fxRatesResponse$ = new BehaviorSubject(null);
    fetchingFxRatesData$ = new BehaviorSubject(null);
    fetchFxRatesSub;
    constructor(serviceRouter, http, logService) {
        this.serviceRouter = serviceRouter;
        this.http = http;
        this.logService = logService;
        this.serviceUrl = this.serviceRouter.getServiceRouteURL(NXIRestServiceDefinition.getInstance());
        this.rateBoardServiceUrl = this.serviceRouter.getServiceRouteURL(ModernRateBoardServiceDefinition.getInstance());
        this.fetchfxRates();
    }
    fetchfxRates() {
        let timeNow = Date.now();
        this.fetchingFxRatesData$.next(true);
        let rateBoardServiceUrl = this.rateBoardServiceUrl + '/fxRate' + '?time=';
        this.fetchFxRatesSub = this.http.get(rateBoardServiceUrl + timeNow).subscribe((response) => {
            const data = response;
            this.fxRatesResponse$.next(data['response']);
            this.fetchingFxRatesData$.next(false);
            this.fxRatesServiceError$.next(null);
        }, (error) => {
            this.logService.error('Error while fetching FxRates: ' + JSON.stringify(error));
            this.fxRatesServiceError$.next(new PershingError('Service Error', 'RateBoardService', 'System Error'));
            this.fetchingFxRatesData$.next(false);
        });
        return this.fetchFxRatesSub;
    }
    fetchRateBoard() {
        let timeNow = Date.now();
        return this.http.get(this.serviceUrl + '/portfolio/get-rateboard' + '?time=' + timeNow);
    }
    getForeignExchangeData() {
        let timeNow = Date.now();
        return this.http.get(this.rateBoardServiceUrl + '/fxRate' + '?time=' + timeNow);
    }
    fetchModernRateBoard() {
        return this.http.get(this.rateBoardServiceUrl + '/getRateboard');
    }
    ngOnDestroy() {
        if (this.fetchFxRatesSub) {
            this.fetchFxRatesSub.unsubscribe();
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RateBoardService, deps: [{ token: i1.ServiceRouter }, { token: i1$1.HttpClient }, { token: i1.LogService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RateBoardService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RateBoardService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.ServiceRouter }, { type: i1$1.HttpClient }, { type: i1.LogService }]; } });

class ForeignExchangeComponent {
    translationService;
    rateBoardService;
    dialog;
    data;
    asOfDate = '';
    universalSymbol = '';
    timeZone = 'America/New_York';
    constructor(translationService, rateBoardService, dialog) {
        this.translationService = translationService;
        this.rateBoardService = rateBoardService;
        this.dialog = dialog;
        this.translationService.addTranslationFolder('@pershing/nxi-ng-rateboard', 'node_modules/@pershing/nxi-ng-rateboard/app');
    }
    ngOnInit() {
        this.rateBoardService.getForeignExchangeData().subscribe((resp) => {
            if (resp.response && resp.response.length > 0) {
                this.data = resp.response;
                this.asOfDate = moment(this.data[0].asOfDate)
                    .tz(this.timeZone)
                    .format('MMM DD, YYYY');
            }
        });
    }
    closeDialog() {
        this.dialog.closeAll();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ForeignExchangeComponent, deps: [{ token: i1.PershingTranslationService }, { token: RateBoardService }, { token: i1$2.MatLegacyDialog }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ForeignExchangeComponent, selector: "modern-theme-foreign-exchange", ngImport: i0, template: "<div class = \"rb-ForeignExchangeDialog_Header padding-left-20 margin-0\" mat-dialog-title>\n    <div class = \"rb-ForeignExchangeDialog_Title\">\n        {{'FOREIGNEXCHANGE.FOREIGNEXCHANGERATE' | translate}}\n    </div>\n    <button class=\"rb-ForeignExchangeDialog_Close\" type=\"button\" class=\"close\" aria-label=\"Close\"\n        (click)=\"closeDialog()\">\n        <span aria-hidden=\"true\"> &times;</span>\n    </button>\n</div>\n<mat-dialog-content class = \"rb-ForeignExchangeDialog_Content\">\n    <div class = \"rb-ForeignExchangeDialog_Asof right small\">\n        {{'FOREIGNEXCHANGE.ASOF' | translate}} {{asOfDate}}\n    </div>\n    <table aria-describedby=\"Foreignexchange\" class = \"rb-ForeignExchangeDialog_Table table margin-bottom-20\">\n        <th id=\"empty\"></th>\n        <tbody>\n            <tr *ngFor=\"let item of data\">\n                <ng-container *ngIf = \"item.symbol !== 'USD'\">\n                    <td class=\"padding-left-20\">{{'FOREIGNEXCHANGE.ONE' | translate}} {{item.symbol}} = {{(1/item.closePrice | number : '1.5-5')}} {{'FOREIGNEXCHANGE.USD' | translate}}</td>\n                    <td>{{'FOREIGNEXCHANGE.ONE' | translate}} {{data[0].symbol}} = {{item.closePrice | number : '1.5-5'}} {{item.symbol}}</td>\n                </ng-container>\n            </tr>\n        </tbody>\n    </table>\n    <div class=\"rb-ForeignExchangeDialog_Disclosure\">\n     {{'fxRates.disclaimer'| translate}}\n    </div>\n</mat-dialog-content>\n\n", dependencies: [{ kind: "directive", type: i1$2.MatLegacyDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$2.MatLegacyDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i4$1.TranslatePipe, name: "translate" }, { kind: "pipe", type: i4.DecimalPipe, name: "number" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ForeignExchangeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'modern-theme-foreign-exchange', template: "<div class = \"rb-ForeignExchangeDialog_Header padding-left-20 margin-0\" mat-dialog-title>\n    <div class = \"rb-ForeignExchangeDialog_Title\">\n        {{'FOREIGNEXCHANGE.FOREIGNEXCHANGERATE' | translate}}\n    </div>\n    <button class=\"rb-ForeignExchangeDialog_Close\" type=\"button\" class=\"close\" aria-label=\"Close\"\n        (click)=\"closeDialog()\">\n        <span aria-hidden=\"true\"> &times;</span>\n    </button>\n</div>\n<mat-dialog-content class = \"rb-ForeignExchangeDialog_Content\">\n    <div class = \"rb-ForeignExchangeDialog_Asof right small\">\n        {{'FOREIGNEXCHANGE.ASOF' | translate}} {{asOfDate}}\n    </div>\n    <table aria-describedby=\"Foreignexchange\" class = \"rb-ForeignExchangeDialog_Table table margin-bottom-20\">\n        <th id=\"empty\"></th>\n        <tbody>\n            <tr *ngFor=\"let item of data\">\n                <ng-container *ngIf = \"item.symbol !== 'USD'\">\n                    <td class=\"padding-left-20\">{{'FOREIGNEXCHANGE.ONE' | translate}} {{item.symbol}} = {{(1/item.closePrice | number : '1.5-5')}} {{'FOREIGNEXCHANGE.USD' | translate}}</td>\n                    <td>{{'FOREIGNEXCHANGE.ONE' | translate}} {{data[0].symbol}} = {{item.closePrice | number : '1.5-5'}} {{item.symbol}}</td>\n                </ng-container>\n            </tr>\n        </tbody>\n    </table>\n    <div class=\"rb-ForeignExchangeDialog_Disclosure\">\n     {{'fxRates.disclaimer'| translate}}\n    </div>\n</mat-dialog-content>\n\n" }]
        }], ctorParameters: function () { return [{ type: i1.PershingTranslationService }, { type: RateBoardService }, { type: i1$2.MatLegacyDialog }]; } });

class NxiRestService {
    http;
    logService;
    serviceRouter;
    serviceUrl;
    constructor(http, logService, serviceRouter) {
        this.http = http;
        this.logService = logService;
        this.serviceRouter = serviceRouter;
        logService.info('NxiRestService : constructor Initializing');
        this.serviceUrl = this.serviceRouter.getServiceRouteURL(NXIRestServiceDefinition.getInstance());
        logService.info('NxiRestService : URL', this.serviceUrl);
    }
    getNxiPortfolioRestUrlResponse(nxiRestUrl) {
        return this.http.get(this.serviceUrl + '/portfolio/' + nxiRestUrl);
    }
    getBrandedURL() {
        const timeNow = Date.now();
        return this.http.get(this.serviceUrl + '/portfolio/brandedUrl?time=' + timeNow, { responseType: 'json' });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NxiRestService, deps: [{ token: i1$1.HttpClient }, { token: i1.LogService }, { token: i1.ServiceRouter }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NxiRestService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NxiRestService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: i1.LogService }, { type: i1.ServiceRouter }]; } });

class LoginReviewDialogComponent {
    translationService;
    dialogRef;
    logService;
    nxiRestService;
    http;
    serviceRouter;
    storageService;
    community;
    ibdName;
    secondsLeft = 10;
    interval;
    serviceUrl;
    brandedurl;
    validSession = false;
    constructor(translationService, appSettings, dialogRef, logService, nxiRestService, http, serviceRouter, storageService) {
        this.translationService = translationService;
        this.dialogRef = dialogRef;
        this.logService = logService;
        this.nxiRestService = nxiRestService;
        this.http = http;
        this.serviceRouter = serviceRouter;
        this.storageService = storageService;
        this.serviceUrl = this.serviceRouter.getServiceRouteURL(NXIRestServiceDefinition.getInstance());
        if (appSettings.ibdConfigMap) {
            let parsemap = appSettings.ibdConfigMap;
            this.community = parsemap.community;
            this.ibdName = parsemap.ibdName;
        }
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
    }
    startTimer() {
        this.logService.info('timer starting in popup');
        this.interval = setInterval(() => {
            if (this.secondsLeft > 0) {
                this.secondsLeft--;
            }
            else {
                this.endSession();
            }
        }, 1000);
    }
    endSession() {
        this.logService.info('logout session');
        this.logout('timedOut');
    }
    cancelDialog() {
        this.dialogRef.close();
    }
    ngOnDestroy() {
        // this.closeDialog();
    }
    ngOnInit() {
        this.startTimer();
        this.getBrandedURL();
    }
    redirectTheUser() {
        this.logout('timedOut');
    }
    logout(message) {
        this.logService.info('Invoking Logout');
        this.resetLocalStorage();
        this.serviceUrl = this.serviceRouter.getServiceRouteURL(NXIRestServiceDefinition.getInstance());
        let params = new HttpParams();
        if (message) {
            params = params.append('message', message);
        }
        else {
            params = params.append('message', '');
        }
        this.http
            .get(this.serviceUrl + '/session/logout', {
            params,
            responseType: 'json',
        })
            .subscribe((data) => {
            console.log('logout Url is ' + data);
            if (message) {
                location.href = this.brandedurl + '/nxi/login';
            }
            else {
                location.href = this.brandedurl + '/nxi/login';
            }
        }, (err) => {
            location.href = this.brandedurl + '/nxi/login';
        });
    }
    getBrandedURL() {
        this.nxiRestService.getBrandedURL().subscribe((resp) => {
            this.brandedurl = resp;
        });
    }
    resetLocalStorage() {
        this.validSession = false;
        if (localStorage.getItem('token')) {
            localStorage.removeItem('token');
        }
        // for nxp login - will be removed
        if (localStorage.getItem('cookie')) {
            localStorage.removeItem('cookie');
        }
        sessionStorage.removeItem('nav_current_pageid');
        sessionStorage.removeItem('realTimeActive');
        if (sessionStorage.getItem('vendorKeepAliveUrl')) {
            sessionStorage.removeItem('vendorKeepAliveUrl');
        }
        if (this.storageService.getItem('nxiSelectedAccountValue')) {
            this.storageService.removeItem('nxiSelectedAccountValue');
        }
        if (sessionStorage.getItem('isThemeSelectionPopupShown')) {
            sessionStorage.removeItem('isThemeSelectionPopupShown');
        }
        if (sessionStorage.getItem('isGABannerClosedByUser')) {
            sessionStorage.removeItem('isGABannerClosedByUser');
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoginReviewDialogComponent, deps: [{ token: i1.PershingTranslationService }, { token: 'AppSettings', optional: true }, { token: i1$2.MatLegacyDialogRef }, { token: i1.LogService }, { token: NxiRestService }, { token: i1$1.HttpClient }, { token: i1.ServiceRouter }, { token: i1.StorageService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: LoginReviewDialogComponent, selector: "login-review-dialog", ngImport: i0, template: "<div mat-dialog-title class=\"padding-top-10 padding-bottom-10\">\n    <div role=\"heading\" class=\"col-sm-10  padding-left-0 padding-right-0\">\n            <h3 role=\"heading\">{{'LOGINMESSAGEHEADING' | translate}}</h3>\n    </div>\n    <button aria-label=\"Close\" role=\"button\" class=\"close\" (click)=\"cancelDialog()\">\n        <i class=\"fa fa-times-circle-o fa-x faclose\" role=\"button\" aria-label=\"Close\" (click)=\"cancelDialog()\"\n            aria-hidden=\"true\"></i>\n    </button>\n</div>\n<mat-dialog-content class=\"dialog-content\">\n    <div  class=\"loginReviewTemplate\"> {{'LOGINMESSAGECONT1' | translate}} {{ibdName}} {{'LOGINMESSAGECONT2' | translate}}<br/><br/> {{'LOGINMESSAGECONT3' | translate}}\n      <a href=\"javascript:void(0);\" (click)=\"redirectTheUser()\">here</a>.\n    </div>\n</mat-dialog-content>\n", dependencies: [{ kind: "directive", type: i1$2.MatLegacyDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$2.MatLegacyDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "pipe", type: i4$1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoginReviewDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'login-review-dialog', template: "<div mat-dialog-title class=\"padding-top-10 padding-bottom-10\">\n    <div role=\"heading\" class=\"col-sm-10  padding-left-0 padding-right-0\">\n            <h3 role=\"heading\">{{'LOGINMESSAGEHEADING' | translate}}</h3>\n    </div>\n    <button aria-label=\"Close\" role=\"button\" class=\"close\" (click)=\"cancelDialog()\">\n        <i class=\"fa fa-times-circle-o fa-x faclose\" role=\"button\" aria-label=\"Close\" (click)=\"cancelDialog()\"\n            aria-hidden=\"true\"></i>\n    </button>\n</div>\n<mat-dialog-content class=\"dialog-content\">\n    <div  class=\"loginReviewTemplate\"> {{'LOGINMESSAGECONT1' | translate}} {{ibdName}} {{'LOGINMESSAGECONT2' | translate}}<br/><br/> {{'LOGINMESSAGECONT3' | translate}}\n      <a href=\"javascript:void(0);\" (click)=\"redirectTheUser()\">here</a>.\n    </div>\n</mat-dialog-content>\n" }]
        }], ctorParameters: function () { return [{ type: i1.PershingTranslationService }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['AppSettings']
                }] }, { type: i1$2.MatLegacyDialogRef }, { type: i1.LogService }, { type: NxiRestService }, { type: i1$1.HttpClient }, { type: i1.ServiceRouter }, { type: i1.StorageService }]; } });

class NXICommonConstants {
    static ShowLanguageSwitchPagesList = [
    // 'login',
    // 'login1',
    // 'welcome',
    // 'registration'
    ];
}
var CustomDateFormat;
(function (CustomDateFormat) {
    CustomDateFormat["mediumDate"] = "MMM dd, y";
    CustomDateFormat["longDate"] = "MMMM dd, y";
    CustomDateFormat["shortDate"] = "MM/dd/yyyy";
})(CustomDateFormat || (CustomDateFormat = {}));

const LANGUAGES = [
    { key: 'en_US', label: 'English' },
    { key: 'es_LA', label: 'Español' },
];
class LanguageSwitchComponent {
    translationService;
    overlay;
    dialog;
    nxiRestService;
    router;
    themeType;
    languages = LANGUAGES;
    showPopup = false;
    locale;
    isMobile = false;
    isTablet = false;
    isSpanishEnabledIBD = false;
    isLoggedInUser = false;
    isGeneric = false;
    showPreloginPageLink = false;
    showSpanishLink = false;
    showEnglishLink = false;
    brandedurl;
    langPopupOrigin;
    langPopupTemplate;
    overlayRef;
    constructor(appSettings, translationService, overlay, dialog, nxiRestService, router) {
        this.translationService = translationService;
        this.overlay = overlay;
        this.dialog = dialog;
        this.nxiRestService = nxiRestService;
        this.router = router;
        this.translationService.addTranslationFolder('@pershing/nxi-ng-common', 'node_modules/@pershing/nxi-ng-common/lib');
        if (appSettings.themeType && appSettings.themeType === 'ada') {
            this.themeType = 'ada';
        }
        else if (appSettings.themeType && appSettings.themeType === 'modern') {
            this.themeType = 'modern';
        }
        else {
            this.themeType = 'standard';
        }
        if (appSettings.deviceType && appSettings.deviceType === 'mobile') {
            this.isMobile = true;
        }
        if (appSettings.deviceType && appSettings.deviceType === 'tablet') {
            this.isTablet = true;
        }
        if (appSettings.locale) {
            this.locale = appSettings.locale;
        }
        let spanishSiteEnabledIBDs = appSettings.ibdConfigMap.spanishSiteEnabledIBD;
        if (spanishSiteEnabledIBDs?.includes(appSettings.ibdConfigMap.IBD) ||
            (appSettings.ibdConfigMap.generic &&
                appSettings.ibdConfigMap.community === 'netxinvestor')) {
            this.isSpanishEnabledIBD = true;
        }
        this.isLoggedInUser = appSettings.isLoggedIn;
        this.isGeneric = appSettings.ibdConfigMap.generic;
        let currRoute = window.location.pathname;
        this.router.events.subscribe((url) => {
            if (url.url) {
                currRoute = url.url;
            }
            let urlArray = currRoute.split('/');
            if (urlArray[urlArray.length - 1].split('?').length > 1) {
                urlArray[urlArray.length - 1] =
                    urlArray[urlArray.length - 1].split('?')[0];
            }
            else if (urlArray[urlArray.length - 1].split('#').length > 1) {
                urlArray[urlArray.length - 1] =
                    urlArray[urlArray.length - 1].split('#')[0];
            }
            else if (urlArray[urlArray.length - 1].split(';').length > 1) {
                urlArray[urlArray.length - 1] =
                    urlArray[urlArray.length - 1].split(';')[0];
            }
            let lastIndex = urlArray[urlArray.length - 1];
            if (NXICommonConstants.ShowLanguageSwitchPagesList.indexOf(lastIndex) === -1) {
                this.showPreloginPageLink = true;
            }
            else {
                this.showPreloginPageLink = false;
            }
        });
        if (this.locale && this.locale === 'es_LA') {
            this.showEnglishLink = true;
            this.showSpanishLink = false;
        }
        else {
            this.showSpanishLink = true;
            this.showEnglishLink = false;
        }
    }
    ngAfterContentChecked() { }
    async switchLanguage(language) {
        if (language === 'en_US' &&
            this.isSpanishEnabledIBD &&
            this.isLoggedInUser &&
            this.isGeneric) {
            this.brandedurl = await this.getBrandedURL();
            if (this.brandedurl) {
                this.loginMessageDialog();
                return;
            }
        }
        let url = location.href;
        if (language !== this.locale) {
            let hashTag = null;
            if (url.includes('#')) {
                let tempArray = url.split('#');
                url = tempArray[0];
                hashTag = tempArray[1];
            }
            let tempURL = this.parseURL(url, language);
            if (hashTag) {
                location.href = tempURL + '#' + hashTag;
            }
            else {
                location.href = tempURL;
            }
        }
    }
    parseURL(url, language) {
        let tempArray = url.split('?');
        let baseURL = tempArray[0];
        let qString = tempArray[1];
        if (!qString) {
            qString = 'isMfe=true&isModern=true';
        }
        let jsonObject = PershingHttpUtil.getJsonObjectFromQueryString(qString);
        jsonObject.lang = language;
        let queryString = PershingHttpUtil.getQueryStringFromJsonObject(jsonObject);
        url = baseURL + '?' + queryString;
        return url;
    }
    openPopup() {
        let strategy = this.overlay
            .position()
            .flexibleConnectedTo(this.langPopupOrigin.elementRef)
            .withPositions([
            {
                originX: 'center',
                originY: 'bottom',
                overlayX: 'end',
                overlayY: 'top',
            },
        ]);
        let config = new OverlayConfig({ positionStrategy: strategy });
        this.overlayRef = this.overlay.create(config);
        this.overlayRef.attach(this.langPopupTemplate);
        this.showPopup = true;
        if (this.locale) {
            let showLink = this.languages.find((c) => c.key !== this.locale);
            setTimeout(function () {
                document.getElementById(showLink.key)['href'] = 'javascript:void(0)';
            }, 500);
        }
        console.log('opened popup');
    }
    closePopup() {
        if (this.showPopup) {
            this.overlayRef.dispose();
            this.showPopup = false;
            console.log('closed');
        }
    }
    loginMessageDialog() {
        const dialogConfig = new MatLegacyDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.minWidth = '250px';
        dialogConfig.panelClass = ['modal', ''];
        this.dialog.open(LoginReviewDialogComponent, dialogConfig);
    }
    ngOnInit() { }
    getBrandedURL() {
        return this.nxiRestService.getBrandedURL().toPromise();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LanguageSwitchComponent, deps: [{ token: 'AppSettings', optional: true }, { token: i1.PershingTranslationService }, { token: i2$1.Overlay }, { token: i1$2.MatLegacyDialog }, { token: NxiRestService }, { token: i5.Router }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: LanguageSwitchComponent, selector: "language-switch", viewQueries: [{ propertyName: "langPopupOrigin", first: true, predicate: ["langPopupOrigin"], descendants: true }, { propertyName: "langPopupTemplate", first: true, predicate: ["langPopupTemplate"], descendants: true }], ngImport: i0, template: "<pershing-responsive [respondToWindow]=\"true\"\u00A0\u00A0\u00A0\u00A0[small]=\"smallRef\" \u00A0\u00A0\u00A0\u00A0[medium]=\"largeRef\" \u00A0\u00A0\u00A0\u00A0[large]=\"largeRef\">\n</pershing-responsive>\n\n<ng-template #largeRef>\n\t<ng-container *ngIf=\"!!themeType && themeType === 'modern' && showPreloginPageLink && showSpanishLink\">\n\t\t<a href=\"javascript:void(0);\" class=\"fw-Header_SwitchLang\" (click)=\"switchLanguage('es_LA')\" [attr.title]=\"'Change page language to ' + ('SPANISH' | translate)\">\n      {{'SPANISH' | translate}}\n    </a>\n\t</ng-container>\n\t<ng-container *ngIf=\"!!themeType && themeType === 'modern' && showPreloginPageLink && showEnglishLink\">\n\t\t<a href=\"javascript:void(0);\" class=\"fw-Header_SwitchLang\" (click)=\"switchLanguage('en_US')\" [attr.title]=\"'Change page language to ' + ('ENGLISH' | translate)\">\n      {{'ENGLISH' | translate}}\n    </a>\n\t</ng-container>\n</ng-template>\n\n<ng-template #smallRef>\n\t<ng-container *ngIf=\"!!themeType && themeType === 'modern' && showPreloginPageLink && showSpanishLink\">\n\t\t<a href=\"javascript:void(0);\" class=\"fw-Header_SwitchLang\" (click)=\"switchLanguage('es_LA')\" [attr.title]=\"'Change page language to ' + ('SPANISH' | translate)\">\n      {{'SPANISH' | translate}}\n    </a>\n\t</ng-container>\n\t<ng-container *ngIf=\"!!themeType && themeType === 'modern' && showPreloginPageLink && showEnglishLink\">\n\t\t<a href=\"javascript:void(0);\" class=\"fw-Header_SwitchLang\" (click)=\"switchLanguage('en_US')\" [attr.title]=\"'Change page language to ' + ('ENGLISH' | translate)\">\n      {{'ENGLISH' | translate}}\n    </a>\n\t</ng-container>\n</ng-template>\n\n<ng-container *ngIf=\"!!themeType && themeType === 'standard'\">\n\t<button #tooltip=\"matTooltip\" matTooltip=\"{{'LANGUAGE_TOOTLTIP' | translate }}\" (click)=\"openPopup()\" matTooltipPosition=\"below\" style=\"display: block;\" mat-icon-button class=\"fw-Icons-language\" cdkOverlayOrigin #langPopupOrigin=\"cdkOverlayOrigin\">\n\t\t<i [ngClass]=\"{'fas fa-globe-americas fa-lg': (!isMobile && !isTablet), 'icon-globe': (isMobile || isTablet)}\" aria-hidden=\"true\"></i>\n\t</button>\n\t<ng-template cdk-portal #langPopupTemplate=\"cdkPortal\">\n\t\t<mat-card class=\"fw-Header_LangDisplayContainer\" id=\"lang-selection-popup\" (mouseleave)=\"closePopup()\" *ngIf=\"showPopup\">\n\t\t\t<mat-card-header>\n\t\t\t\t<mat-card-title>{{ 'SELECT_LANGUAGE' | translate}}</mat-card-title>\n\t\t\t\t<button role=\"button\" aria-label=\"Close\" class=\"close\" (click)=\"closePopup()\">\n\t\t\t\t\t<i class=\"fa fa-times-circle-o fa-x\" (click)=\"closePopup()\" aria-hidden=\"true\"></i>\n\t\t\t\t</button>\n\t\t\t</mat-card-header>\n\t\t\t<mat-card-content>\n\t\t\t\t<ul>\n\t\t\t\t\t<li *ngFor=\"let language of languages\">\n\t\t\t\t\t\t<a id=\"{{language.key}}\" (click)=\"switchLanguage(language.key)\">\n\t\t\t\t\t\t\t<span>{{language.label}}</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t</mat-card-content>\n\t\t</mat-card>\n\t </ng-template>\n</ng-container>\n\n<ng-container *ngIf=\"!!themeType && themeType === 'ada' && !showPreloginPageLink\">\n\t <a href=\"javascript:void(0);\" (click)=\"openPopup()\" cdkOverlayOrigin #langPopupOrigin=\"cdkOverlayOrigin\" aria-hidden=\"true\">{{'SWITCH_LANGUAGE' | translate}}</a>\n\t <ng-template cdk-portal #langPopupTemplate=\"cdkPortal\">\n\t\t<mat-card class=\"fw-Header_LangDisplayContainer\" (mouseleave)=\"closePopup()\" *ngIf=\"showPopup\" id=\"lang-selection-popup\">\n\t\t\t<mat-card-header>\n\t\t\t\t<mat-card-title>{{ 'SELECT_LANGUAGE' | translate}}</mat-card-title>\n\t\t\t\t<button role=\"button\" aria-label=\"Close\" class=\"close\" (click)=\"closePopup()\" (mouseleave)=\"closePopup()\">\n\t\t\t\t\t<i class=\"fa fa-times-circle-o fa-x\" (click)=\"closePopup()\" aria-hidden=\"true\"></i>\n\t\t\t\t</button>\n\t\t\t</mat-card-header>\n\t\t\t<mat-card-content>\n\t\t\t\t<ul>\n\t\t\t\t\t<li *ngFor=\"let language of languages\">\n\t\t\t\t\t\t<a id=\"{{language.key}}\" (click)=\"switchLanguage(language.key)\">\n\t\t\t\t\t\t\t<span>{{language.label}}</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t</mat-card-content>\n\t\t</mat-card>\n\t</ng-template>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i6$2.TemplatePortalDirective, selector: "[cdk-portal], [portal]", exportAs: ["cdkPortal"] }, { kind: "component", type: i7.MatLegacyButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i8.MatLegacyTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "component", type: i9.MatLegacyCard, selector: "mat-card", exportAs: ["matCard"] }, { kind: "component", type: i9.MatLegacyCardHeader, selector: "mat-card-header" }, { kind: "directive", type: i9.MatLegacyCardContent, selector: "mat-card-content, [mat-card-content], [matCardContent]" }, { kind: "directive", type: i9.MatLegacyCardTitle, selector: "mat-card-title, [mat-card-title], [matCardTitle]" }, { kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i11.PershingResponsiveComponent, selector: "pershing-responsive", inputs: ["respondToWindow", "small", "medium", "large"] }, { kind: "directive", type: i2$1.CdkOverlayOrigin, selector: "[cdk-overlay-origin], [overlay-origin], [cdkOverlayOrigin]", exportAs: ["cdkOverlayOrigin"] }, { kind: "pipe", type: i4$1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LanguageSwitchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'language-switch', template: "<pershing-responsive [respondToWindow]=\"true\"\u00A0\u00A0\u00A0\u00A0[small]=\"smallRef\" \u00A0\u00A0\u00A0\u00A0[medium]=\"largeRef\" \u00A0\u00A0\u00A0\u00A0[large]=\"largeRef\">\n</pershing-responsive>\n\n<ng-template #largeRef>\n\t<ng-container *ngIf=\"!!themeType && themeType === 'modern' && showPreloginPageLink && showSpanishLink\">\n\t\t<a href=\"javascript:void(0);\" class=\"fw-Header_SwitchLang\" (click)=\"switchLanguage('es_LA')\" [attr.title]=\"'Change page language to ' + ('SPANISH' | translate)\">\n      {{'SPANISH' | translate}}\n    </a>\n\t</ng-container>\n\t<ng-container *ngIf=\"!!themeType && themeType === 'modern' && showPreloginPageLink && showEnglishLink\">\n\t\t<a href=\"javascript:void(0);\" class=\"fw-Header_SwitchLang\" (click)=\"switchLanguage('en_US')\" [attr.title]=\"'Change page language to ' + ('ENGLISH' | translate)\">\n      {{'ENGLISH' | translate}}\n    </a>\n\t</ng-container>\n</ng-template>\n\n<ng-template #smallRef>\n\t<ng-container *ngIf=\"!!themeType && themeType === 'modern' && showPreloginPageLink && showSpanishLink\">\n\t\t<a href=\"javascript:void(0);\" class=\"fw-Header_SwitchLang\" (click)=\"switchLanguage('es_LA')\" [attr.title]=\"'Change page language to ' + ('SPANISH' | translate)\">\n      {{'SPANISH' | translate}}\n    </a>\n\t</ng-container>\n\t<ng-container *ngIf=\"!!themeType && themeType === 'modern' && showPreloginPageLink && showEnglishLink\">\n\t\t<a href=\"javascript:void(0);\" class=\"fw-Header_SwitchLang\" (click)=\"switchLanguage('en_US')\" [attr.title]=\"'Change page language to ' + ('ENGLISH' | translate)\">\n      {{'ENGLISH' | translate}}\n    </a>\n\t</ng-container>\n</ng-template>\n\n<ng-container *ngIf=\"!!themeType && themeType === 'standard'\">\n\t<button #tooltip=\"matTooltip\" matTooltip=\"{{'LANGUAGE_TOOTLTIP' | translate }}\" (click)=\"openPopup()\" matTooltipPosition=\"below\" style=\"display: block;\" mat-icon-button class=\"fw-Icons-language\" cdkOverlayOrigin #langPopupOrigin=\"cdkOverlayOrigin\">\n\t\t<i [ngClass]=\"{'fas fa-globe-americas fa-lg': (!isMobile && !isTablet), 'icon-globe': (isMobile || isTablet)}\" aria-hidden=\"true\"></i>\n\t</button>\n\t<ng-template cdk-portal #langPopupTemplate=\"cdkPortal\">\n\t\t<mat-card class=\"fw-Header_LangDisplayContainer\" id=\"lang-selection-popup\" (mouseleave)=\"closePopup()\" *ngIf=\"showPopup\">\n\t\t\t<mat-card-header>\n\t\t\t\t<mat-card-title>{{ 'SELECT_LANGUAGE' | translate}}</mat-card-title>\n\t\t\t\t<button role=\"button\" aria-label=\"Close\" class=\"close\" (click)=\"closePopup()\">\n\t\t\t\t\t<i class=\"fa fa-times-circle-o fa-x\" (click)=\"closePopup()\" aria-hidden=\"true\"></i>\n\t\t\t\t</button>\n\t\t\t</mat-card-header>\n\t\t\t<mat-card-content>\n\t\t\t\t<ul>\n\t\t\t\t\t<li *ngFor=\"let language of languages\">\n\t\t\t\t\t\t<a id=\"{{language.key}}\" (click)=\"switchLanguage(language.key)\">\n\t\t\t\t\t\t\t<span>{{language.label}}</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t</mat-card-content>\n\t\t</mat-card>\n\t </ng-template>\n</ng-container>\n\n<ng-container *ngIf=\"!!themeType && themeType === 'ada' && !showPreloginPageLink\">\n\t <a href=\"javascript:void(0);\" (click)=\"openPopup()\" cdkOverlayOrigin #langPopupOrigin=\"cdkOverlayOrigin\" aria-hidden=\"true\">{{'SWITCH_LANGUAGE' | translate}}</a>\n\t <ng-template cdk-portal #langPopupTemplate=\"cdkPortal\">\n\t\t<mat-card class=\"fw-Header_LangDisplayContainer\" (mouseleave)=\"closePopup()\" *ngIf=\"showPopup\" id=\"lang-selection-popup\">\n\t\t\t<mat-card-header>\n\t\t\t\t<mat-card-title>{{ 'SELECT_LANGUAGE' | translate}}</mat-card-title>\n\t\t\t\t<button role=\"button\" aria-label=\"Close\" class=\"close\" (click)=\"closePopup()\" (mouseleave)=\"closePopup()\">\n\t\t\t\t\t<i class=\"fa fa-times-circle-o fa-x\" (click)=\"closePopup()\" aria-hidden=\"true\"></i>\n\t\t\t\t</button>\n\t\t\t</mat-card-header>\n\t\t\t<mat-card-content>\n\t\t\t\t<ul>\n\t\t\t\t\t<li *ngFor=\"let language of languages\">\n\t\t\t\t\t\t<a id=\"{{language.key}}\" (click)=\"switchLanguage(language.key)\">\n\t\t\t\t\t\t\t<span>{{language.label}}</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t</mat-card-content>\n\t\t</mat-card>\n\t</ng-template>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['AppSettings']
                }] }, { type: i1.PershingTranslationService }, { type: i2$1.Overlay }, { type: i1$2.MatLegacyDialog }, { type: NxiRestService }, { type: i5.Router }]; }, propDecorators: { langPopupOrigin: [{
                type: ViewChild,
                args: ['langPopupOrigin']
            }], langPopupTemplate: [{
                type: ViewChild,
                args: ['langPopupTemplate']
            }] } });

class NXIMISCServiceDefinition {
    static instance;
    version = 'v1';
    family = 'netxinvestor';
    appName = 'miscellaneous-svc';
    serviceName = 'app';
    mnemonic = 'nxc';
    uri = '';
    static getInstance() {
        if (!NXIMISCServiceDefinition.instance) {
            NXIMISCServiceDefinition.instance = new NXIMISCServiceDefinition();
        }
        return NXIMISCServiceDefinition.instance;
    }
}

class NXIAccountService {
    http;
    serviceRouter;
    appDataStore;
    isNickNameUpdated$ = new BehaviorSubject(null);
    serviceUrl;
    restUri;
    modernService;
    accountParam;
    accountList_ = new BehaviorSubject(null);
    accountList$ = this.accountList_.asObservable();
    IFC;
    businesscodeid;
    formHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(http, serviceRouter, appDataStore, appSettings) {
        this.http = http;
        this.serviceRouter = serviceRouter;
        this.appDataStore = appDataStore;
        this.restUri = this.serviceRouter.getServiceRouteURL(NXIMISCServiceDefinition.getInstance());
        this.serviceUrl = this.serviceRouter.getServiceRouteURL(NXIRestServiceDefinition.getInstance());
        this.modernService = appSettings?.ibdConfigMap?.modernAccountService || false;
        this.IFC = appSettings?.ibdConfigMap?.IFC;
        this.businesscodeid = appSettings?.ibdConfigMap?.businesscode;
    }
    convertQueryParamToObj(queryParams) {
        const param = {};
        if (queryParams === null) {
            return param;
        }
        for (const query in queryParams) {
            if (queryParams.hasOwnProperty(query)) {
                param[query] = queryParams[query];
            }
        }
        return param;
    }
    fetchUserAccounts(isManagedAccountsPage, isHouseHoldPage, isTrading, isTrading529, queryParams) {
        console.log('isManagedAccountsPage ==>' + this.appDataStore.get('isManagedAccountsPage'));
        console.log('isHouseHoldPage ==>' + this.appDataStore.get('isHouseHoldPage'));
        let params;
        if (queryParams) {
            params = this.convertQueryParamToObj(queryParams);
        }
        if (this.accountList_.getValue() && !!params && !params.forceFetch && this.validateAccountParam(isManagedAccountsPage, isHouseHoldPage, isTrading, isTrading529)) {
            this.accountList_.next(this.accountList_.getValue());
        }
        else {
            let url;
            this.accountParam = { isManagedAccountsPage: isManagedAccountsPage, isHouseHoldPage: isHouseHoldPage, isTrading: isTrading, isTrading529: isTrading529 };
            if (this.modernService != null && this.modernService) {
                url = this.restUri + '/subscriberAccounts/getPortfolioAccounts';
                params = {
                    ifc: this.IFC ?? null,
                    businessCode: this.businesscodeid ?? null,
                };
                this.accountfetch(url, isManagedAccountsPage, isHouseHoldPage, isTrading, isTrading529, params);
                // Rest service account forcefetch is done here since we rely on rest service at few places
                this.accountfetch(this.serviceUrl + '/portfolio/accounts', isManagedAccountsPage, isHouseHoldPage, isTrading, isTrading529, params);
            }
            else {
                url = this.serviceUrl + '/portfolio/accounts';
                this.accountfetch(url, isManagedAccountsPage, isHouseHoldPage, isTrading, isTrading529, params);
            }
        }
        return this.accountList$;
    }
    accountfetch(url, isManagedAccountsPage, isHouseHoldPage, isTrading, isTrading529, params) {
        this.http.get(url, { responseType: 'json', params }).subscribe((data) => {
            if (!!data && data.length > 1) {
                this.appDataStore.put('isManagedAccountsPage', 'false');
                this.appDataStore.put('isHouseHoldPage', 'false');
                const group = data.filter(function (account) { return account.group || account.acctNo === 'ALL'; });
                const ungrouped = data.filter(function (account) { return !account.group && account.acctNo !== 'ALL'; });
                const ungroupedIconied = ungrouped.map(account => this.updateDisplay(account, isManagedAccountsPage, isHouseHoldPage));
                const groupIconied = group.map(account => this.updateDisplay(account, isManagedAccountsPage, isHouseHoldPage));
                let accountsList = groupIconied.concat(ungroupedIconied);
                // added this check because code inside was refactored from updateDisplay function
                this.putManagedAndHouseHoldPage(accountsList, isHouseHoldPage, isManagedAccountsPage);
                accountsList = this.updateAccountList(accountsList, isManagedAccountsPage, isHouseHoldPage, isTrading, isTrading529);
                this.appDataStore.put('ACCOUNTS_LIST', accountsList);
                this.accountList_.next(accountsList);
            }
            else {
                this.accountList_.next([]);
            }
        }, error => {
            this.accountList_.next([]);
        });
    }
    validateAccountParam(isManagedAccountsPage, isHouseHoldPage, isTrading, isTrading529) {
        if ((this.accountParam) && (this.accountParam.isManagedAccountsPage != isManagedAccountsPage
            || this.accountParam.isHouseHoldPage != isHouseHoldPage
            || this.accountParam.isTrading != isTrading
            || this.accountParam.isTrading529 != isTrading529)) {
            return false;
        }
        return true;
    }
    putManagedAndHouseHoldPage(accountsList, isHouseHoldPage, isManagedAccountsPage) {
        if (accountsList.length > 1) {
            // null and undefined check
            if (!isHouseHoldPage) {
                isHouseHoldPage = false;
            }
            if (isManagedAccountsPage) {
                this.appDataStore.put('isManagedAccountsPage', isManagedAccountsPage);
            }
            else {
                this.appDataStore.put('isHouseHoldPage', isHouseHoldPage);
            }
        }
    }
    updateDisplay(account, isManagedAccountsPage, isHouseHoldPage) {
        if (isManagedAccountsPage) {
            account.showIcon = account.pesIdInd === 'L' || account.hhIcon;
        }
        else {
            account.showIcon = isHouseHoldPage && (account.pesIdInd === 'L' || account.hhIcon || account.acctTypeCode === 'L');
        }
        return account;
    }
    updateAccountList(accountsList, isManagedAccountsPage, isHouseHoldPage, isTrading, isTrading529) {
        const tempIndvAccountlist = [];
        for (const account of accountsList) {
            if (account.acctNo === 'ALL' && accountsList.length === 2) {
                continue;
            }
            if (isManagedAccountsPage) {
                if (account.pesIdInd === 'L' || account.hhIcon) {
                    tempIndvAccountlist.push(account);
                }
            }
            else {
                this.nonManagedAccountsPage(isTrading529, isTrading, account, tempIndvAccountlist, isHouseHoldPage);
            }
        }
        accountsList = tempIndvAccountlist;
        return accountsList;
    }
    nonManagedAccountsPage(isTrading529, isTrading, account, tempIndvAccountlist, isHouseHoldPage) {
        if (isTrading529 || isTrading) {
            if (isTrading && account.tradingEnabled) {
                tempIndvAccountlist.push(account);
            }
            if (isTrading529 && account.trading529Enabled) {
                tempIndvAccountlist.push(account);
            }
        }
        else {
            tempIndvAccountlist.push(account);
            if (!isHouseHoldPage && account.group && (account.acctTypeCode === 'L' || account.hhIcon)) {
                tempIndvAccountlist.pop();
            }
        }
    }
    // Add,edit,delete nickname of account
    updateNickName(accountNo, updatedNickName) {
        const body = {
            'accountNum': accountNo,
            'nickname': updatedNickName
        };
        return this.http.post(this.restUri + '/account/updatenickname', body, { headers: this.formHeaders, observe: 'body' });
    }
    editGroup(editData) {
        const body = {
            'groupDescription': editData.oldGroupName
        };
        if (!!editData.groupName) {
            body['newGroupDescription'] = editData.groupName;
        }
        if (!!editData.removedAccounts && editData.removedAccounts.length > 0) {
            body['removedAccounts'] = editData.removedAccounts;
        }
        if (!!editData.accounts && editData.accounts.length > 0) {
            body['accounts'] = editData.accounts;
        }
        return this.http.post(this.restUri + '/account/editgroup', body, { headers: this.formHeaders, observe: 'body' });
    }
    deleteGroup(groupName) {
        const body = new HttpParams();
        return this.http.post(this.restUri + '/account/deletegroup/' + groupName, body, { headers: this.formHeaders, observe: 'body' });
    }
    addGroup(accountList, groupName) {
        const body = {
            groupDescription: groupName,
            accountList: accountList
        };
        return this.http.post(this.restUri + '/account/addgroup', body, { headers: this.formHeaders, observe: 'body' });
    }
    setNickNameFlag(flag) {
        this.isNickNameUpdated$.next(flag);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NXIAccountService, deps: [{ token: i1$1.HttpClient }, { token: i1.ServiceRouter }, { token: i1.AppDataStore }, { token: 'AppSettings', optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NXIAccountService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NXIAccountService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: i1.ServiceRouter }, { type: i1.AppDataStore }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['AppSettings']
                }] }]; } });

class NguCarouselStore {
    touch;
    vertical;
    interval;
    transform;
    button;
    visibleItems;
    deviceType;
    type;
    token;
    items;
    load;
    deviceWidth;
    carouselWidth;
    itemWidth;
    slideItems;
    itemWidthPer;
    itemLength;
    currentSlide;
    easing;
    speed;
    loop;
    dexVal;
    touchTransform;
    isEnd;
    isFirst;
    isLast;
    RTL;
    point;
    velocity;
    constructor(touch = new Touch(), vertical = new Vertical(), interval, transform = new Transfrom(), button, visibleItems, deviceType, type = 'fixed', token = '', items = 0, load = 0, deviceWidth = 0, carouselWidth = 0, itemWidth = 0, slideItems = 0, itemWidthPer = 0, itemLength = 0, currentSlide = 0, easing = 'cubic-bezier(0, 0, 0.2, 1)', speed = 200, loop = false, dexVal = 0, touchTransform = 0, isEnd = false, isFirst = true, isLast = false, RTL = false, point = true, velocity = 1) {
        this.touch = touch;
        this.vertical = vertical;
        this.interval = interval;
        this.transform = transform;
        this.button = button;
        this.visibleItems = visibleItems;
        this.deviceType = deviceType;
        this.type = type;
        this.token = token;
        this.items = items;
        this.load = load;
        this.deviceWidth = deviceWidth;
        this.carouselWidth = carouselWidth;
        this.itemWidth = itemWidth;
        this.slideItems = slideItems;
        this.itemWidthPer = itemWidthPer;
        this.itemLength = itemLength;
        this.currentSlide = currentSlide;
        this.easing = easing;
        this.speed = speed;
        this.loop = loop;
        this.dexVal = dexVal;
        this.touchTransform = touchTransform;
        this.isEnd = isEnd;
        this.isFirst = isFirst;
        this.isLast = isLast;
        this.RTL = RTL;
        this.point = point;
        this.velocity = velocity;
    }
}
class ItemsControl {
    start;
    end;
}
class Vertical {
    enabled;
    height;
}
class NguButton {
    visibility;
    elastic;
}
class Touch {
    active;
    swipe;
    velocity;
}
class Transfrom {
    xs;
    sm;
    md;
    lg;
    all;
    xl = 0;
    constructor(xs = 0, sm = 0, md = 0, lg = 0, all = 0) {
        this.xs = xs;
        this.sm = sm;
        this.md = md;
        this.lg = lg;
        this.all = all;
    }
}
/**
 * Default values
 * {sm: 768, md: 992, lg: 1200, xl: 1200}
 *
 * Bootstrap values:
 * {sm: 576, md: 768, lg: 992, xl: 1200}
 */
class Breakpoints {
    sm;
    md;
    lg;
    xl;
    constructor(sm = 768, md = 992, lg = 1200, xl = 1200) {
        this.sm = sm;
        this.md = md;
        this.lg = lg;
        this.xl = xl;
    }
}
class NguCarouselConfig {
    grid;
    gridBreakpoints;
    slide;
    speed;
    interval;
    animation;
    point;
    type;
    load;
    custom;
    loop;
    touch;
    easing;
    RTL;
    button;
    vertical;
    velocity;
}
class NguCarouselOutletContext {
    /** Data for the node. */
    $implicit;
    /** Depth of the node. */
    level;
    /** Index location of the node. */
    index;
    /** Length of the number of total dataNodes. */
    count;
    constructor(data) {
        this.$implicit = data;
    }
}

class NxiCarouselComponent {
    myCarousel;
    customContent;
    pageConfig;
    set config(pageConfig) {
        if (pageConfig) {
            this.pageConfig = pageConfig;
            this.setCarouselConfig(pageConfig);
        }
    }
    summary;
    set carouselData(summary) {
        if (summary) {
            this.summary = summary;
            this.myCarousel?.moveTo(0, true);
        }
    }
    onTileClick = new EventEmitter();
    carouselConfig;
    enableTouch;
    constructor(appSettings) {
        this.enableTouch = appSettings.deviceType !== 'desktop';
    }
    setCarouselConfig(pageConfig) {
        let grid = {
            xs: pageConfig.tilesPerResolution.xSmall,
            sm: pageConfig.tilesPerResolution.small,
            md: pageConfig.tilesPerResolution.medium,
            lg: pageConfig.tilesPerResolution.large,
            xl: pageConfig.tilesPerResolution.xLarge,
            all: 0
        };
        this.carouselConfig = {
            grid: grid,
            gridBreakpoints: new Breakpoints(576, 768, 992, 1200),
            speed: 500,
            point: {
                visible: true
            },
            load: 2,
            velocity: 0,
            touch: this.enableTouch,
            easing: 'cubic-bezier(0, 0, 0.2, 1)'
        };
    }
    onClick(summary) {
        console.log('inside-click', summary);
        if (!(summary.highlight)) {
            let index = this.summary.findIndex(e => e.highlight === true);
            if (index !== -1) {
                this.summary[index].highlight = false;
            }
            summary.highlight = true;
            this.onTileClick.emit(summary);
            console.log('event-emitted', summary);
        }
    }
    handleKeydown(event, tile) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault(); // Prevent default action for space key
            if (this.pageConfig?.clickOptions?.enable) {
                this.onClick(tile);
            }
        }
    }
    handleClick(event) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            const target = event.target;
            target.click();
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NxiCarouselComponent, deps: [{ token: 'AppSettings', optional: true }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: NxiCarouselComponent, selector: "nxi-carousel", inputs: { config: "config", carouselData: "carouselData" }, outputs: { onTileClick: "onTileClick" }, queries: [{ propertyName: "customContent", first: true, predicate: TemplateRef, descendants: true }], viewQueries: [{ propertyName: "myCarousel", first: true, predicate: ["myCarousel"], descendants: true }], ngImport: i0, template: "<pershing-responsive *ngIf=\"pageConfig && summary\" [respondToWindow]=\"true\" [large]=\"largeRef\" [medium]=\"mediumRef\" [small]=\"smallRef\">\n</pershing-responsive>\n\n<ng-template #largeRef>\n    <ng-template [ngTemplateOutlet]=\"carousel\"\n        [ngTemplateOutletContext]=\"{enableIndicators : pageConfig.enableIndicators.large}\"></ng-template>\n</ng-template>\n\n<ng-template #mediumRef>\n    <ng-template [ngTemplateOutlet]=\"carousel\"\n        [ngTemplateOutletContext]=\"{enableIndicators : pageConfig.enableIndicators.medium}\"></ng-template>\n</ng-template>\n\n<ng-template #smallRef>\n    <ng-template [ngTemplateOutlet]=\"carousel\"\n        [ngTemplateOutletContext]=\"{enableIndicators : pageConfig.enableIndicators.small}\"></ng-template>\n</ng-template>\n\n<ng-template #carousel let-enableIndicators=\"enableIndicators\">\n    <div role=\"tablist\" class=\"nc-Summary\">\n        <ngu-carousel #myCarousel [inputs]=\"carouselConfig\" [dataSource]=\"summary\">\n            <div class=\"item\" *nguCarouselDef=\"let tile;let i=index\">\n                <mat-card role=\"tab\" [attr.aria-selected]=\"tile.highlight ? 'true' : 'false'\" [attr.aria-controls]=\"'tabpanel-' + i\"\n                [attr.id]=\"'tab-' + i\" [attr.aria-label]=\"'CarouselTab-' + i\" (click)=\"pageConfig?.clickOptions?.enable && onClick(tile)\" (keypress)=\"pageConfig?.clickOptions?.enable && onClick(tile)\" \n                (keydown)=\"handleKeydown($event, tile)\" [attr.tabindex]=\"pageConfig?.clickOptions?.enable ? '0' : '-1'\"\n                class=\"nc-Summary_Tile {{tile?.borderColor}} {{tile?.customClass}}\" [ngClass]=\"{'nc-Summary_Outline': tile.highlight}\">\n                    <ng-template [ngTemplateOutlet]=\"customContent\" [ngTemplateOutletContext]=\"{tile : tile}\"></ng-template>\n                    <svg *ngIf=\"pageConfig?.clickOptions?.enable && pageConfig?.clickOptions?.arrow && tile?.highlight\" height=\"20px\" width=\"30px\" class=\"reverse-triangle\">\n                        <polygon points=\"0 0,30 0,15 10\" />\n                    </svg>\n                </mat-card>\n            </div>\n            <button NguCarouselPrev class=\"nc-Summary_Arrow left invisibleButton\"\n                [ngClass]=\"{ 'ngucarousel-disable': myCarousel.activePoint === 0 }\" tabindex=\"0\" aria-label=\"Show Previous Account\" (keydown)=\"handleClick($event)\">\n                <em class=\"far fa-chevron-left\"></em>\n            </button>\n            <button NguCarouselNext class=\"nc-Summary_Arrow right invisibleButton\"\n                [ngClass]=\"{ 'ngucarousel-disable': myCarousel.activePoint === myCarousel.pointNumbers[myCarousel.pointNumbers.length - 1] }\" tabindex=\"0\" aria-label=\"Show Next Account\" (keydown)=\"handleClick($event)\">\n                <em class=\"far fa-chevron-right\"></em>\n            </button>\n            <ul *ngIf=\"myCarousel.pointNumbers.length !== 1 && enableIndicators\" class=\"nc-Summary_Indicators\"\n                NguCarouselPoint>\n                <li *ngFor=\"let i of myCarousel.pointNumbers\" class=\"nc-Summary_Indicators-point\"\n                    [class.active]=\"i == myCarousel.activePoint\" (click)=\"myCarousel.moveTo(i)\" (keydown)=\"myCarousel.moveTo(i)\"></li>\n            </ul>\n        </ngu-carousel>\n    </div>\n</ng-template>\n", dependencies: [{ kind: "component", type: i9.MatLegacyCard, selector: "mat-card", exportAs: ["matCard"] }, { kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i11.PershingResponsiveComponent, selector: "pershing-responsive", inputs: ["respondToWindow", "small", "medium", "large"] }, { kind: "component", type: i4$2.NguCarousel, selector: "ngu-carousel", inputs: ["inputs", "dataSource", "trackBy"], outputs: ["carouselLoad", "onMove"] }, { kind: "directive", type: i4$2.NguCarouselPointDirective, selector: "[NguCarouselPoint]" }, { kind: "directive", type: i4$2.NguCarouselNextDirective, selector: "[NguCarouselNext]" }, { kind: "directive", type: i4$2.NguCarouselPrevDirective, selector: "[NguCarouselPrev]" }, { kind: "directive", type: i4$2.NguCarouselDefDirective, selector: "[nguCarouselDef]" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NxiCarouselComponent, decorators: [{
            type: Component,
            args: [{ selector: 'nxi-carousel', template: "<pershing-responsive *ngIf=\"pageConfig && summary\" [respondToWindow]=\"true\" [large]=\"largeRef\" [medium]=\"mediumRef\" [small]=\"smallRef\">\n</pershing-responsive>\n\n<ng-template #largeRef>\n    <ng-template [ngTemplateOutlet]=\"carousel\"\n        [ngTemplateOutletContext]=\"{enableIndicators : pageConfig.enableIndicators.large}\"></ng-template>\n</ng-template>\n\n<ng-template #mediumRef>\n    <ng-template [ngTemplateOutlet]=\"carousel\"\n        [ngTemplateOutletContext]=\"{enableIndicators : pageConfig.enableIndicators.medium}\"></ng-template>\n</ng-template>\n\n<ng-template #smallRef>\n    <ng-template [ngTemplateOutlet]=\"carousel\"\n        [ngTemplateOutletContext]=\"{enableIndicators : pageConfig.enableIndicators.small}\"></ng-template>\n</ng-template>\n\n<ng-template #carousel let-enableIndicators=\"enableIndicators\">\n    <div role=\"tablist\" class=\"nc-Summary\">\n        <ngu-carousel #myCarousel [inputs]=\"carouselConfig\" [dataSource]=\"summary\">\n            <div class=\"item\" *nguCarouselDef=\"let tile;let i=index\">\n                <mat-card role=\"tab\" [attr.aria-selected]=\"tile.highlight ? 'true' : 'false'\" [attr.aria-controls]=\"'tabpanel-' + i\"\n                [attr.id]=\"'tab-' + i\" [attr.aria-label]=\"'CarouselTab-' + i\" (click)=\"pageConfig?.clickOptions?.enable && onClick(tile)\" (keypress)=\"pageConfig?.clickOptions?.enable && onClick(tile)\" \n                (keydown)=\"handleKeydown($event, tile)\" [attr.tabindex]=\"pageConfig?.clickOptions?.enable ? '0' : '-1'\"\n                class=\"nc-Summary_Tile {{tile?.borderColor}} {{tile?.customClass}}\" [ngClass]=\"{'nc-Summary_Outline': tile.highlight}\">\n                    <ng-template [ngTemplateOutlet]=\"customContent\" [ngTemplateOutletContext]=\"{tile : tile}\"></ng-template>\n                    <svg *ngIf=\"pageConfig?.clickOptions?.enable && pageConfig?.clickOptions?.arrow && tile?.highlight\" height=\"20px\" width=\"30px\" class=\"reverse-triangle\">\n                        <polygon points=\"0 0,30 0,15 10\" />\n                    </svg>\n                </mat-card>\n            </div>\n            <button NguCarouselPrev class=\"nc-Summary_Arrow left invisibleButton\"\n                [ngClass]=\"{ 'ngucarousel-disable': myCarousel.activePoint === 0 }\" tabindex=\"0\" aria-label=\"Show Previous Account\" (keydown)=\"handleClick($event)\">\n                <em class=\"far fa-chevron-left\"></em>\n            </button>\n            <button NguCarouselNext class=\"nc-Summary_Arrow right invisibleButton\"\n                [ngClass]=\"{ 'ngucarousel-disable': myCarousel.activePoint === myCarousel.pointNumbers[myCarousel.pointNumbers.length - 1] }\" tabindex=\"0\" aria-label=\"Show Next Account\" (keydown)=\"handleClick($event)\">\n                <em class=\"far fa-chevron-right\"></em>\n            </button>\n            <ul *ngIf=\"myCarousel.pointNumbers.length !== 1 && enableIndicators\" class=\"nc-Summary_Indicators\"\n                NguCarouselPoint>\n                <li *ngFor=\"let i of myCarousel.pointNumbers\" class=\"nc-Summary_Indicators-point\"\n                    [class.active]=\"i == myCarousel.activePoint\" (click)=\"myCarousel.moveTo(i)\" (keydown)=\"myCarousel.moveTo(i)\"></li>\n            </ul>\n        </ngu-carousel>\n    </div>\n</ng-template>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['AppSettings']
                }] }]; }, propDecorators: { myCarousel: [{
                type: ViewChild,
                args: ['myCarousel']
            }], customContent: [{
                type: ContentChild,
                args: [TemplateRef]
            }], config: [{
                type: Input
            }], carouselData: [{
                type: Input
            }], onTileClick: [{
                type: Output
            }] } });

class RedirectConfirmationPopupComponent {
    dialogData;
    dialogRef;
    translationService;
    redirectUrl;
    constructor(dialogData, dialogRef, translationService) {
        this.dialogData = dialogData;
        this.dialogRef = dialogRef;
        this.translationService = translationService;
        this.redirectUrl = dialogData.redirectUrl;
        this.translationService.addTranslationFolder('@pershing/nxi-ng-common', 'node_modules/@pershing/nxi-ng-common/lib');
    }
    onContinue() {
        window.open(this.redirectUrl, '_blank');
        this.onCancelClick();
    }
    onCancelClick() {
        this.dialogRef.close();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RedirectConfirmationPopupComponent, deps: [{ token: MAT_LEGACY_DIALOG_DATA }, { token: i1$2.MatLegacyDialogRef }, { token: i1.PershingTranslationService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: RedirectConfirmationPopupComponent, selector: "redirect-confirmation-popup", ngImport: i0, template: "<div mat-dialog-title>\n    <h1>{{'REDIRECT_CONFIRMATION.TITLE'| translate}}</h1>\n    <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"onCancelClick()\">\n      <span aria-hidden=\"true\"> &times;</span>\n    </button>\n  </div>\n  <div mat-dialog-content class=\"mat-dialog-content-padded\">\n    <P>{{'REDIRECT_CONFIRMATION.CONTENT'| translate}}</P>\n  </div>\n  \n  <div mat-dialog-actions>\n    <div class=\"action-buttons\">\n      <button mat-raised-button  color=\"primary\" (click)=\"onContinue()\">{{'REDIRECT_CONFIRMATION.CONTINUE' | translate }}</button>\n      <button mat-stroked-button color=\"primary\" (click)=\"onCancelClick()\">{{'REDIRECT_CONFIRMATION.CLOSE' | translate}}</button>\n    </div>\n  </div>", dependencies: [{ kind: "component", type: i7.MatLegacyButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i1$2.MatLegacyDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$2.MatLegacyDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$2.MatLegacyDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "pipe", type: i4$1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RedirectConfirmationPopupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'redirect-confirmation-popup', template: "<div mat-dialog-title>\n    <h1>{{'REDIRECT_CONFIRMATION.TITLE'| translate}}</h1>\n    <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"onCancelClick()\">\n      <span aria-hidden=\"true\"> &times;</span>\n    </button>\n  </div>\n  <div mat-dialog-content class=\"mat-dialog-content-padded\">\n    <P>{{'REDIRECT_CONFIRMATION.CONTENT'| translate}}</P>\n  </div>\n  \n  <div mat-dialog-actions>\n    <div class=\"action-buttons\">\n      <button mat-raised-button  color=\"primary\" (click)=\"onContinue()\">{{'REDIRECT_CONFIRMATION.CONTINUE' | translate }}</button>\n      <button mat-stroked-button color=\"primary\" (click)=\"onCancelClick()\">{{'REDIRECT_CONFIRMATION.CLOSE' | translate}}</button>\n    </div>\n  </div>" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_LEGACY_DIALOG_DATA]
                }] }, { type: i1$2.MatLegacyDialogRef }, { type: i1.PershingTranslationService }]; } });

class NXISecurityService {
    authorizationService;
    isModToolEnabled = false;
    constructor(authorizationService) {
        this.authorizationService = authorizationService;
        this.isModToolEnabled = this.authorizationService.isEntitled('MOD_QUOTES_NEWS');
    }
    getMODAccessURL(security) {
        if (security.symbol) {
            let invalidSymbol = this.checkInvalidSymbol(security);
            security.value = security.symbol;
            if (this.CheckValidSymbol(security, invalidSymbol)) {
                this.getMODURL(security);
            }
        }
        else {
            security.value = security.cusip;
        }
        return security;
    }
    getMODURL(security) {
        if (!!security.assetType) {
            security.showLink = true;
            if (security.assetType === 'MUTFUND') {
                security.modURL = '/nxi/research/quotenews/mutualfunds/mfsummary';
            }
            else if (security.assetType === 'EQUITY' && security.assetSubType === 'ETF') {
                security.modURL = '/nxi/research/quotenews/etf/etfsummary';
            }
            else {
                security.modURL = '/nxi/research/quotenews/stocks/summary';
            }
        }
    }
    CheckValidSymbol(security, invalidSymbol) {
        return this.isModToolEnabled && security.symbol.indexOf(':') === -1 && !invalidSymbol;
    }
    checkInvalidSymbol(security) {
        return security.symbol.indexOf(' ') === 0 || security.symbol.indexOf(' ') === security.symbol.length - 1;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NXISecurityService, deps: [{ token: i1.PermissionCheckerService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NXISecurityService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NXISecurityService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.PermissionCheckerService }]; } });

class PdfService {
    http;
    constructor(http) {
        this.http = http;
    }
    generatePDF(url, data) {
        return this.http.post(url, data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, responseType: 'arraybuffer' });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PdfService, deps: [{ token: i1$1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PdfService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PdfService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }]; } });

class ViewPdfComponent {
    dialogData;
    dialogRef;
    pdfService;
    translationService;
    src;
    isLoading = false;
    showError = false;
    zoom = 1;
    page = 1;
    totalPages;
    constructor(dialogData, dialogRef, pdfService, translationService) {
        this.dialogData = dialogData;
        this.dialogRef = dialogRef;
        this.pdfService = pdfService;
        this.translationService = translationService;
        this.translationService.addTranslationFolder('@pershing/nxi-ng-common', 'node_modules/@pershing/nxi-ng-common/lib');
    }
    ngOnInit() {
        this.isLoading = true;
        if (this.dialogData) {
            if (this.dialogData.reqUrl) {
                this.isLoading = false;
                this.src = this.dialogData.reqUrl;
            }
            else if (this.dialogData.fetchData) {
                this.pdfService.generatePDF(this.dialogData.fetchData.endPointUrl, this.dialogData.fetchData.reqBody).subscribe((res) => {
                    this.isLoading = false;
                    this.createData(res);
                }, (error) => {
                    this.isLoading = false;
                    this.showError = true;
                    console.error(error);
                });
            }
        }
    }
    createData(data) {
        let view = data;
        let docFormat = 'application/pdf';
        let file3 = new Blob([view], { type: docFormat });
        let bloburl = URL.createObjectURL(file3);
        this.src = bloburl;
    }
    closeDialog() {
        this.dialogRef.close();
    }
    zoomIn() {
        this.zoom += 0.1;
    }
    zoomOut() {
        if (this.zoom >= 0.2) {
            this.zoom -= 0.1;
        }
    }
    onPdfLoadComplete(pdf) {
        this.totalPages = pdf.numPages;
    }
    nextPage() {
        if (this.page < this.totalPages) {
            this.page++;
        }
    }
    prevPage() {
        if (this.page > 1) {
            this.page--;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ViewPdfComponent, deps: [{ token: MAT_LEGACY_DIALOG_DATA }, { token: i1$2.MatLegacyDialogRef }, { token: PdfService }, { token: i1.PershingTranslationService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ViewPdfComponent, selector: "app-view-pdf", ngImport: i0, template: "<div mat-dialog-title class=\"padding-10\">\n  <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"closeDialog()\">\n      <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n\n<div class=\"margin-top-10 center-align\">\n  <button mat-icon-button type=\"button\">\n    <a (click)=\"zoomIn()\">\n      <em class=\"fas fa-search-plus\"></em>\n    </a>\n  </button>\n  <button class=\"margin-right-20\" mat-icon-button type=\"button\">\n    <a (click)=\"zoomOut()\">\n      <em class=\"fas fa-search-minus\"></em>\n    </a>\n  </button>\n \n  <button (click)=\"prevPage()\" mat-icon-button type=\"button\" [disabled]=\"page<=1\">\n      <em class=\"fas fa-chevron-left\"></em>\n  </button>\n  <span>{{ page }} of {{ totalPages }}</span>\n  <button (click)=\"nextPage()\" mat-icon-button type=\"button\" [disabled]=\"page>=totalPages\">\n      <em class=\"fas fa-chevron-right\"></em>\n  </button>\n  <button class=\"margin-left-20\" mat-icon-button type=\"button\">\n    <a [href]=\"src\" download>\n      <em class=\"fas fa-download\"></em>\n    </a>\n  </button>\n</div>\n<mat-spinner [diameter]=\"20\" *ngIf=\"isLoading\"></mat-spinner>\n    <div  mat-dialog-content *ngIf=\"showError\">\n      <pershing-message displayType=\"inpage\" messageType=\"error\" role=\"alertdialog\" aria-live=\"polite\"\n          message=\"{{'NXI_PORTAL.FAILED_DOCUMENT' | translate}}\">\n      </pershing-message>\n    </div>\n<div mat-dialog-content *ngIf=\"!isLoading\" class=\"mat-dialog-content margin-top-0\">\n    <pdf-viewer\n      [src]=\"src\"\n      [rotation]=\"0\"\n      [original-size]=\"false\"\n      [show-all]=\"false\"\n      [fit-to-page]=\"true\"\n      [zoom]=\"zoom\"\n      [zoom-scale]=\"'page-width'\"\n      [stick-to-page]=\"true\"\n      [render-text]=\"true\"\n      [external-link-target]=\"'blank'\"\n      [show-borders]=\"false\"\n      [page]=\"page\"\n      (after-load-complete)=\"onPdfLoadComplete($event)\"\n      style=\"width: 100%; height: 80vh; display: block;\"\n    ></pdf-viewer>\n  </div>\n  \n", dependencies: [{ kind: "component", type: i7.MatLegacyButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i1$2.MatLegacyDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$2.MatLegacyDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "component", type: i2.MatLegacyProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "diameter", "strokeWidth", "mode", "value"], exportAs: ["matProgressSpinner"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i11.PershingMessageComponent, selector: "pershing-message", inputs: ["displayType", "messageType", "message", "callbackOnLinkClick", "linkButtonId", "buttonLabel", "hideAfterInterval", "width", "isDisplayDialogOnChange"], outputs: ["notifyActionClicked"] }, { kind: "component", type: i8$1.PdfViewerComponent, selector: "pdf-viewer", inputs: ["src", "c-maps-url", "page", "render-text", "render-text-mode", "original-size", "show-all", "stick-to-page", "zoom", "zoom-scale", "rotation", "external-link-target", "autoresize", "fit-to-page", "show-borders"], outputs: ["after-load-complete", "page-rendered", "pages-initialized", "text-layer-rendered", "error", "on-progress", "pageChange"] }, { kind: "pipe", type: i4$1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ViewPdfComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-view-pdf', template: "<div mat-dialog-title class=\"padding-10\">\n  <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"closeDialog()\">\n      <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n\n<div class=\"margin-top-10 center-align\">\n  <button mat-icon-button type=\"button\">\n    <a (click)=\"zoomIn()\">\n      <em class=\"fas fa-search-plus\"></em>\n    </a>\n  </button>\n  <button class=\"margin-right-20\" mat-icon-button type=\"button\">\n    <a (click)=\"zoomOut()\">\n      <em class=\"fas fa-search-minus\"></em>\n    </a>\n  </button>\n \n  <button (click)=\"prevPage()\" mat-icon-button type=\"button\" [disabled]=\"page<=1\">\n      <em class=\"fas fa-chevron-left\"></em>\n  </button>\n  <span>{{ page }} of {{ totalPages }}</span>\n  <button (click)=\"nextPage()\" mat-icon-button type=\"button\" [disabled]=\"page>=totalPages\">\n      <em class=\"fas fa-chevron-right\"></em>\n  </button>\n  <button class=\"margin-left-20\" mat-icon-button type=\"button\">\n    <a [href]=\"src\" download>\n      <em class=\"fas fa-download\"></em>\n    </a>\n  </button>\n</div>\n<mat-spinner [diameter]=\"20\" *ngIf=\"isLoading\"></mat-spinner>\n    <div  mat-dialog-content *ngIf=\"showError\">\n      <pershing-message displayType=\"inpage\" messageType=\"error\" role=\"alertdialog\" aria-live=\"polite\"\n          message=\"{{'NXI_PORTAL.FAILED_DOCUMENT' | translate}}\">\n      </pershing-message>\n    </div>\n<div mat-dialog-content *ngIf=\"!isLoading\" class=\"mat-dialog-content margin-top-0\">\n    <pdf-viewer\n      [src]=\"src\"\n      [rotation]=\"0\"\n      [original-size]=\"false\"\n      [show-all]=\"false\"\n      [fit-to-page]=\"true\"\n      [zoom]=\"zoom\"\n      [zoom-scale]=\"'page-width'\"\n      [stick-to-page]=\"true\"\n      [render-text]=\"true\"\n      [external-link-target]=\"'blank'\"\n      [show-borders]=\"false\"\n      [page]=\"page\"\n      (after-load-complete)=\"onPdfLoadComplete($event)\"\n      style=\"width: 100%; height: 80vh; display: block;\"\n    ></pdf-viewer>\n  </div>\n  \n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_LEGACY_DIALOG_DATA]
                }] }, { type: i1$2.MatLegacyDialogRef }, { type: PdfService }, { type: i1.PershingTranslationService }]; } });

const COMMON_COMPONENTS = [
    CMSTextComponent,
    ContentManagementComponent,
    ProgressDialogComponent,
    ComponentTitleComponent,
    ImageContentComponent,
    AccountDisplayPipe,
    DownloadExcelComponent,
    ForeignExchangeComponent,
    LoginReviewDialogComponent,
    LanguageSwitchComponent,
    NxiCarouselComponent,
    RedirectConfirmationPopupComponent,
    ViewPdfComponent
];
const SERVICE_PROVIDERS = [
    ContentManagementService,
    ContentStudioService,
    NxiIconsService,
    SafePipe,
    AccountDisplayPipe,
    GridExportService,
    PortalNavigationService,
    NxiMobileService,
    PershingTranslationService,
    NxiRestService,
    NXIAccountService,
    RateBoardService,
    NXISecurityService,
    PdfService
];
class NxiNgCommonModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NxiNgCommonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: NxiNgCommonModule, declarations: [CMSTextComponent,
            ContentManagementComponent,
            ProgressDialogComponent,
            ComponentTitleComponent,
            ImageContentComponent,
            AccountDisplayPipe,
            DownloadExcelComponent,
            ForeignExchangeComponent,
            LoginReviewDialogComponent,
            LanguageSwitchComponent,
            NxiCarouselComponent,
            RedirectConfirmationPopupComponent,
            ViewPdfComponent, SafePipe, AccountDisplayPipe], imports: [MatLegacyRadioModule,
            FormsModule,
            ReactiveFormsModule,
            PortalModule,
            AngularEditorModule,
            MatLegacyButtonModule,
            MatLegacyDialogModule,
            MatLegacyProgressSpinnerModule,
            MatLegacyAutocompleteModule,
            MatLegacyTooltipModule,
            MatIconModule,
            MatLegacySelectModule,
            MatLegacyOptionModule,
            MatLegacyFormFieldModule,
            MatLegacyInputModule,
            MatLegacyMenuModule,
            MatDividerModule,
            MatExpansionModule,
            MatLegacyCardModule,
            PershingCoreModule,
            PershingCommonModule,
            PerNgPlatformServiceModule,
            OverlayModule,
            NguCarouselModule,
            PdfViewerModule], exports: [CMSTextComponent,
            ContentManagementComponent,
            ProgressDialogComponent,
            ComponentTitleComponent,
            ImageContentComponent,
            AccountDisplayPipe,
            DownloadExcelComponent,
            ForeignExchangeComponent,
            LoginReviewDialogComponent,
            LanguageSwitchComponent,
            NxiCarouselComponent,
            RedirectConfirmationPopupComponent,
            ViewPdfComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NxiNgCommonModule, providers: [...SERVICE_PROVIDERS], imports: [MatLegacyRadioModule,
            FormsModule,
            ReactiveFormsModule,
            PortalModule,
            AngularEditorModule,
            MatLegacyButtonModule,
            MatLegacyDialogModule,
            MatLegacyProgressSpinnerModule,
            MatLegacyAutocompleteModule,
            MatLegacyTooltipModule,
            MatIconModule,
            MatLegacySelectModule,
            MatLegacyOptionModule,
            MatLegacyFormFieldModule,
            MatLegacyInputModule,
            MatLegacyMenuModule,
            MatDividerModule,
            MatExpansionModule,
            MatLegacyCardModule,
            PershingCoreModule,
            PershingCommonModule,
            PerNgPlatformServiceModule,
            OverlayModule,
            NguCarouselModule,
            PdfViewerModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NxiNgCommonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        MatLegacyRadioModule,
                        FormsModule,
                        ReactiveFormsModule,
                        PortalModule,
                        AngularEditorModule,
                        MatLegacyButtonModule,
                        MatLegacyDialogModule,
                        MatLegacyProgressSpinnerModule,
                        MatLegacyAutocompleteModule,
                        MatLegacyTooltipModule,
                        MatIconModule,
                        MatLegacySelectModule,
                        MatLegacyOptionModule,
                        MatLegacyFormFieldModule,
                        MatLegacyInputModule,
                        MatLegacyMenuModule,
                        MatDividerModule,
                        MatExpansionModule,
                        MatLegacyCardModule,
                        PershingCoreModule,
                        PershingCommonModule,
                        PerNgPlatformServiceModule,
                        OverlayModule,
                        NguCarouselModule,
                        PdfViewerModule
                    ],
                    declarations: [...COMMON_COMPONENTS, SafePipe, AccountDisplayPipe],
                    providers: [...SERVICE_PROVIDERS],
                    exports: [...COMMON_COMPONENTS],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

class NxiConfigUtil {
    static getCommunityName(appSettings) {
        let configMap = this.getIbdConfigMap(appSettings);
        let community = configMap && configMap.community ? configMap.community : 'netxinvestor';
        return community;
    }
    static getIbdConfigMap(appSettings) {
        let parsemap = {};
        if (appSettings && appSettings.ibdConfigMap) {
            parsemap = appSettings.ibdConfigMap;
        }
        return parsemap;
    }
}

class AppDataService {
    store = {};
    constructor() {
        console.log('AppDataService instantiated');
    }
    exists(key) {
        return (key in this.store);
    }
    delete(key) {
        delete this.store[key];
    }
    deleteAll() {
        Object.keys(this.store).forEach((key) => {
            this.delete(key);
        });
    }
    get(key) {
        if (this.exists(key)) {
            return this.store[key].asObservable();
        }
        else {
            this.store[key] = new ReplaySubject(1);
            return this.store[key].asObservable();
        }
    }
    put(key, value, react = true) {
        if (this.exists(key)) {
            this.store[key].next({ value: value, react: react });
        }
        else {
            this.store[key] = new ReplaySubject(1);
            this.store[key].next({ value: value, react: react });
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AppDataService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AppDataService, providedIn: 'platform' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AppDataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }], ctorParameters: function () { return []; } });

class NxiContextResponse {
    inputValue;
    hashValue;
}

class NxiContextUtils {
    static getContextFromDomainValue(domainContext) {
        let response = new NxiContextResponse();
        let contextValue = domainContext.value;
        if (contextValue instanceof AccountContextValue) {
            response.inputValue = contextValue.accountNumber;
            response.hashValue = contextValue.hashValue;
        }
        else if (contextValue instanceof ClientContextValue) {
            response.inputValue = contextValue.clientId;
        }
        else if (contextValue instanceof HouseholdContextValue || contextValue instanceof GroupContextValue) {
            response.inputValue = contextValue.groupId;
            response.hashValue = contextValue.hashValue; // For HH and Group
        }
        else {
            response.inputValue = '';
        }
        return response;
    }
}

class NxiNavigation {
    parentPage;
    childPage;
    grandchildPage;
    fourthchildPage;
    constructor(parent, child, grandchild, fourthchild) {
        this.parentPage = parent;
        this.childPage = child;
        this.grandchildPage = grandchild;
        this.fourthchildPage = fourthchild;
    }
}

class NxiCustomDateFormatPipe {
    dp;
    constructor(dp) {
        this.dp = dp;
    }
    transform(value, dateformat) {
        return this.dp.transform(value, dateformat).toString();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NxiCustomDateFormatPipe, deps: [{ token: i4.DatePipe }], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: NxiCustomDateFormatPipe, name: "customDateFormat" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NxiCustomDateFormatPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'customDateFormat' }]
        }], ctorParameters: function () { return [{ type: i4.DatePipe }]; } });

class NxiNumberFormatPipe {
    dp;
    constructor(dp) {
        this.dp = dp;
    }
    transform(value) {
        if (value !== null && value !== undefined && value !== "") {
            return this.dp.transform(value, '1.2-4', '');
        }
        else {
            return '';
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NxiNumberFormatPipe, deps: [{ token: i4.DecimalPipe }], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: NxiNumberFormatPipe, name: "numberFormat" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NxiNumberFormatPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'numberFormat' }]
        }], ctorParameters: function () { return [{ type: i4.DecimalPipe }]; } });

class NxiCurrencyFormatPipe {
    cp;
    constructor(cp) {
        this.cp = cp;
    }
    transform(value) {
        if (value !== null && value !== undefined && value !== "") {
            return this.cp.transform(value, '', 'symbol-narrow', '1.2-2', '');
        }
        else {
            return '';
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NxiCurrencyFormatPipe, deps: [{ token: i4.CurrencyPipe }], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: NxiCurrencyFormatPipe, name: "currencyFormat" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NxiCurrencyFormatPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'currencyFormat' }]
        }], ctorParameters: function () { return [{ type: i4.CurrencyPipe }]; } });

/*
 * Public API Surface of nxi-ng-common
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccountDisplayPipe, AppDataService, Breakpoints, CMSTextComponent, COMMON_COMPONENTS, ComponentTitleComponent, ContentManagementComponent, CustomDateFormat, DownloadExcelComponent, ForeignExchangeComponent, GridExportService, ImageContentComponent, ItemsControl, LanguageSwitchComponent, LoginReviewDialogComponent, NXIAccountService, NXISecurityService, NguButton, NguCarouselConfig, NguCarouselOutletContext, NguCarouselStore, NxiCarouselComponent, NxiConfigUtil, NxiContextUtils, NxiCurrencyFormatPipe, NxiCustomDateFormatPipe, NxiNavigation, NxiNgCommonModule, NxiNumberFormatPipe, PdfService, PortalNavigationService, ProgressDialogComponent, RedirectConfirmationPopupComponent, SERVICE_PROVIDERS, Touch, Transfrom, Vertical, ViewPdfComponent };
